(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@fiverr/globals"), require("react"), require("prop-types"));
	else if(typeof define === 'function' && define.amd)
		define(["@fiverr/globals", "react", "prop-types"], factory);
	else if(typeof exports === 'object')
		exports["GigCards"] = factory(require("@fiverr/globals"), require("react"), require("prop-types"));
	else
		root["GigCards"] = factory(root["@fiverr/globals"], root["React"], root["PropTypes"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_E4I8__, __WEBPACK_EXTERNAL_MODULE_Jmof__, __WEBPACK_EXTERNAL_MODULE_T9WB__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://npm-assets.fiverrcdn.com/assets/@fiverr/gig_card/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fEuR");
/******/ })
/************************************************************************/
/******/ ({

/***/ "0wUK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "C4SN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CqLJ":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*
 * Date Format 1.2.3
 * (c) 2007-2009 Steven Levithan <stevenlevithan.com>
 * MIT license
 *
 * Includes enhancements by Scott Trenda <scott.trenda.net>
 * and Kris Kowal <cixar.com/~kris.kowal/>
 *
 * Accepts a date, a mask, or a date and a mask.
 * Returns a formatted version of the given date.
 * The date defaults to the current date/time.
 * The mask defaults to dateFormat.masks.default.
 */

(function(global) {
  'use strict';

  var dateFormat = (function() {
      var token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZWN]|'[^']*'|'[^']*'/g;
      var timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g;
      var timezoneClip = /[^-+\dA-Z]/g;
  
      // Regexes and supporting functions are cached through closure
      return function (date, mask, utc, gmt) {
  
        // You can't provide utc if you skip other args (use the 'UTC:' mask prefix)
        if (arguments.length === 1 && kindOf(date) === 'string' && !/\d/.test(date)) {
          mask = date;
          date = undefined;
        }
  
        date = date || new Date;
  
        if(!(date instanceof Date)) {
          date = new Date(date);
        }
  
        if (isNaN(date)) {
          throw TypeError('Invalid date');
        }
  
        mask = String(dateFormat.masks[mask] || mask || dateFormat.masks['default']);
  
        // Allow setting the utc/gmt argument via the mask
        var maskSlice = mask.slice(0, 4);
        if (maskSlice === 'UTC:' || maskSlice === 'GMT:') {
          mask = mask.slice(4);
          utc = true;
          if (maskSlice === 'GMT:') {
            gmt = true;
          }
        }
  
        var _ = utc ? 'getUTC' : 'get';
        var d = date[_ + 'Date']();
        var D = date[_ + 'Day']();
        var m = date[_ + 'Month']();
        var y = date[_ + 'FullYear']();
        var H = date[_ + 'Hours']();
        var M = date[_ + 'Minutes']();
        var s = date[_ + 'Seconds']();
        var L = date[_ + 'Milliseconds']();
        var o = utc ? 0 : date.getTimezoneOffset();
        var W = getWeek(date);
        var N = getDayOfWeek(date);
        var flags = {
          d:    d,
          dd:   pad(d),
          ddd:  dateFormat.i18n.dayNames[D],
          dddd: dateFormat.i18n.dayNames[D + 7],
          m:    m + 1,
          mm:   pad(m + 1),
          mmm:  dateFormat.i18n.monthNames[m],
          mmmm: dateFormat.i18n.monthNames[m + 12],
          yy:   String(y).slice(2),
          yyyy: y,
          h:    H % 12 || 12,
          hh:   pad(H % 12 || 12),
          H:    H,
          HH:   pad(H),
          M:    M,
          MM:   pad(M),
          s:    s,
          ss:   pad(s),
          l:    pad(L, 3),
          L:    pad(Math.round(L / 10)),
          t:    H < 12 ? 'a'  : 'p',
          tt:   H < 12 ? 'am' : 'pm',
          T:    H < 12 ? 'A'  : 'P',
          TT:   H < 12 ? 'AM' : 'PM',
          Z:    gmt ? 'GMT' : utc ? 'UTC' : (String(date).match(timezone) || ['']).pop().replace(timezoneClip, ''),
          o:    (o > 0 ? '-' : '+') + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
          S:    ['th', 'st', 'nd', 'rd'][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10],
          W:    W,
          N:    N
        };
  
        return mask.replace(token, function (match) {
          if (match in flags) {
            return flags[match];
          }
          return match.slice(1, match.length - 1);
        });
      };
    })();

  dateFormat.masks = {
    'default':               'ddd mmm dd yyyy HH:MM:ss',
    'shortDate':             'm/d/yy',
    'mediumDate':            'mmm d, yyyy',
    'longDate':              'mmmm d, yyyy',
    'fullDate':              'dddd, mmmm d, yyyy',
    'shortTime':             'h:MM TT',
    'mediumTime':            'h:MM:ss TT',
    'longTime':              'h:MM:ss TT Z',
    'isoDate':               'yyyy-mm-dd',
    'isoTime':               'HH:MM:ss',
    'isoDateTime':           'yyyy-mm-dd\'T\'HH:MM:sso',
    'isoUtcDateTime':        'UTC:yyyy-mm-dd\'T\'HH:MM:ss\'Z\'',
    'expiresHeaderFormat':   'ddd, dd mmm yyyy HH:MM:ss Z'
  };

  // Internationalization strings
  dateFormat.i18n = {
    dayNames: [
      'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat',
      'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'
    ],
    monthNames: [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
      'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
    ]
  };

function pad(val, len) {
  val = String(val);
  len = len || 2;
  while (val.length < len) {
    val = '0' + val;
  }
  return val;
}

/**
 * Get the ISO 8601 week number
 * Based on comments from
 * http://techblog.procurios.nl/k/n618/news/view/33796/14863/Calculate-ISO-8601-week-and-year-in-javascript.html
 *
 * @param  {Object} `date`
 * @return {Number}
 */
function getWeek(date) {
  // Remove time components of date
  var targetThursday = new Date(date.getFullYear(), date.getMonth(), date.getDate());

  // Change date to Thursday same week
  targetThursday.setDate(targetThursday.getDate() - ((targetThursday.getDay() + 6) % 7) + 3);

  // Take January 4th as it is always in week 1 (see ISO 8601)
  var firstThursday = new Date(targetThursday.getFullYear(), 0, 4);

  // Change date to Thursday same week
  firstThursday.setDate(firstThursday.getDate() - ((firstThursday.getDay() + 6) % 7) + 3);

  // Check if daylight-saving-time-switch occurred and correct for it
  var ds = targetThursday.getTimezoneOffset() - firstThursday.getTimezoneOffset();
  targetThursday.setHours(targetThursday.getHours() - ds);

  // Number of weeks between target Thursday and first Thursday
  var weekDiff = (targetThursday - firstThursday) / (86400000*7);
  return 1 + Math.floor(weekDiff);
}

/**
 * Get ISO-8601 numeric representation of the day of the week
 * 1 (for Monday) through 7 (for Sunday)
 * 
 * @param  {Object} `date`
 * @return {Number}
 */
function getDayOfWeek(date) {
  var dow = date.getDay();
  if(dow === 0) {
    dow = 7;
  }
  return dow;
}

/**
 * kind-of shortcut
 * @param  {*} val
 * @return {String}
 */
function kindOf(val) {
  if (val === null) {
    return 'null';
  }

  if (val === undefined) {
    return 'undefined';
  }

  if (typeof val !== 'object') {
    return typeof val;
  }

  if (Array.isArray(val)) {
    return 'array';
  }

  return {}.toString.call(val)
    .slice(8, -1).toLowerCase();
};



  if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return dateFormat;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    module.exports = dateFormat;
  } else {
    global.dateFormat = dateFormat;
  }
})(this);


/***/ }),

/***/ "E4I8":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_E4I8__;

/***/ }),

/***/ "HK0U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jmof":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_Jmof__;

/***/ }),

/***/ "LlhT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NYAQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Repj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T9WB":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_T9WB__;

/***/ }),

/***/ "UCFI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "W2uZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WOeT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZpHc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bQni":
/***/ (function(module, exports, __webpack_require__) {

/*
  WeakMap where key (object) is mapped to an array.
  Removing last item from an array removes the key from the map.
 */


/*jshint -W079 */
var WeakMap = __webpack_require__("lP53");

var ArrayWeakMap = function() {

  this._weakMap = new WeakMap();

  this.has = function(mapKey) {
    return this._weakMap.has(mapKey);
  };

  this.addArrayItem = function(mapKey, item) {
    if (this._weakMap.has(mapKey)) {
      this._weakMap.get(mapKey).push(item);
    }
    else {
      this._weakMap.set(mapKey, [item]);
    }
  };

  this.removeArrayItem = function(mapKey, item) {
    if (!this._weakMap.has(mapKey)) {
      return;
    }
    var array = this._weakMap.get(mapKey);
    var idx = array.indexOf(item);

    if (idx >= 0) {
      if (array.length == 1) {
        this._weakMap.delete(mapKey);
      }
      else {
        array.splice(idx, 1);
      }
    }
  };

};

module.exports = ArrayWeakMap;

/***/ }),

/***/ "bv8i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dZ1e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eIBB":
/***/ (function(module, exports) {

module.exports = {"general":{"ok":"Ok","by":"by"},"seller_levels":{"level_one_seller":"Level 1 Seller","level_one_seller_tooltip":"Completed at least 10 orders on time with a minimum 4.8 rating","level_two_seller":"Level 2 Seller","level_two_seller_tooltip":"Completed at least 50 orders on time with a minimum 4.8 rating","top_rated_seller":"Top Rated Seller","top_rated_seller_tooltip":"Vetted by Fiverr and completed at least 100 orders on time with a minimum 4.8 rating","new_pro":"New Pro Seller","new_seller":"New Arrival","pro_spotlight_seller":"Pro Spotlight Seller","pro_spotlight_seller_tooltip":"Leaders and experts in their fields, these sellers are featured on Fiverr for a limited time."},"badges":{"featured":{"caption":"featured","tooltip":"Curated by Fiverr's own editors, these sellers are talented, trustworthy, and reliable"},"available_now":{"caption":"Available Now","tooltip":"The seller is online and available to start working on your project now!"},"fiverrs_choice":{"caption":"Fiverr's Choice"},"pro":{"caption":"","tooltip":"Hand-vetted by Fiverr for the highest quality, talent, and professionalism, less than 0.1% who apply reach this status."},"limited_edition":{"caption":"Limited Edition","tooltip":"These Pro Spotlight Gigs are only available for a short time. Don't miss out!"},"rising_talent":{"caption":"Rising Talent","tooltip":"Rising talent with a high potential, recommended by Fiverr's editors."},"very_reliable":{"caption":"Very Reliable","tooltip":"This seller has an extremely high fulfillment rate"},"ppc":{"caption":"Ad"}},"rating":{"be_the_first_to_rate":"Be the First to Rate"},"price":{"on_average":"On Average","most_successful":"Most successful at","starting_at":"Starting At","from":"From","only":"Only"},"delivery_time":{"tomorrow":"Tomorrow","get_it_by":"Get it by"},"collections":{"add_to_favorites":"Add to Favorites","save_in":"Save in...","add_collection":"Add Collection","collection_name":"Collection Name","errors":{"went_wrong":"We're sorry, something went wrong","length_error":"Name must be 5 to 52 characters","name_new_coll":"Name your new collection"}}}

/***/ }),

/***/ "eLcb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fEuR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: external {"commonjs":"react","commonjs2":"react","amd":"react","root":"React","var":"React"}
var external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__ = __webpack_require__("Jmof");
var external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default = /*#__PURE__*/__webpack_require__.n(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__);

// EXTERNAL MODULE: external {"commonjs":"prop-types","commonjs2":"prop-types","amd":"prop-types","root":"PropTypes","var":"PropTypes"}
var external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes__ = __webpack_require__("T9WB");
var external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default = /*#__PURE__*/__webpack_require__.n(external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes__);

// EXTERNAL MODULE: external "@fiverr/globals"
var globals_ = __webpack_require__("E4I8");
var globals__default = /*#__PURE__*/__webpack_require__.n(globals_);

// EXTERNAL MODULE: ./node_modules/react-store/Store.js
var Store = __webpack_require__("lCso");
var Store_default = /*#__PURE__*/__webpack_require__.n(Store);

// CONCATENATED MODULE: ./src/store/collection/index.js



var _pendingRequests = {},
    collUrl = '/collection_items',
    collHashUrl = '/collections/hash',
    CollectionStore = Store_default.a.extend({
    serializeJson: function serializeJson(ary) {
        return Object.keys(ary).map(function (key) {
            if (Array.isArray(ary[key])) {
                var arrayParts = [];
                for (var i = 0; i < ary[key].length; i++) {
                    arrayParts.push(encodeURIComponent(key + '[]') + '=' + encodeURIComponent(ary[key][i]));
                }
                return arrayParts.join('&');
            }
            return encodeURIComponent(key) + '=' + encodeURIComponent(ary[key]);
        }).join('&');
    },
    getCollections: function getCollections(hearts) {
        if (hearts.length < 1) {
            return {};
        }

        _pendingRequests[collHashUrl] = true;

        return gofor(collHashUrl + '?' + this.serializeJson({ gigs: hearts }), {
            method: 'GET',
            headers: {
                'Accept': 'text/javascript'
            }
        }).then(function (response) {
            return response.ok && response.json();
        }).then(function (data) {
            delete _pendingRequests[collHashUrl];
            return data;
        });
    },
    toggleFavorite: function toggleFavorite(type, gigId, collection) {
        if (!gigId || !collection) {
            return;
        }

        var params = { gig_id: gigId, collection: collection },
            formData = Object.keys(params).map(function (key) {
            return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
        }).join('&');

        _pendingRequests[collUrl] = true;

        return gofor(collUrl, {
            method: type,
            headers: {
                'Accept': 'text/javascript',
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: formData
        }).then(function () {
            delete _pendingRequests[collUrl];
            return 'success';
        }).catch(function (error) {
            throw error;
        });
    },
    newCollection: function newCollection(gigId, collection) {
        if (!gigId || !collection) {
            return;
        }

        var params = { gig_id: gigId, collection: collection },
            formData = Object.keys(params).map(function (key) {
            return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
        }).join('&');

        _pendingRequests[collUrl] = true;

        return gofor(collUrl, {
            method: 'POST',
            headers: {
                'Accept': 'text/javascript',
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: formData
        }).then(function () {
            delete _pendingRequests[collUrl];
            return 'success';
        }).catch(function (response) {
            var error = response.error();

            delete _pendingRequests[collUrl];
            return error && error.responseText ? JSON.parse(error.responseText).error : 'We\'re sorry, something went wrong';
        });
    }
});

/* harmony default export */ var collection = (CollectionStore);
// EXTERNAL MODULE: ./src/translations.en.json
var translations_en = __webpack_require__("eIBB");
var translations_en_default = /*#__PURE__*/__webpack_require__.n(translations_en);

// EXTERNAL MODULE: ./node_modules/@fiverr/fit/dist/index.js
var dist = __webpack_require__("tBbN");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// EXTERNAL MODULE: ./src/shared/badge/style.scss
var style = __webpack_require__("0wUK");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// CONCATENATED MODULE: ./src/shared/badge/index.js






var BADGE_CASES = {
    FEATURED: 'featured',
    CHOICE: 'choice',
    PRO: 'pro',
    LIMITED: 'limited',
    HIGH_COMPLETION: 'high_completion',
    TALENT: 'talent'
};

var badge_Badge = function Badge(_ref) {
    var type = _ref.type,
        className = _ref.className;

    var badge = void 0,
        leftAlign = void 0;

    switch (type) {
        case BADGE_CASES.FEATURED:
            badge = external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                dist["Status"],
                { classes: 'featured badge-hint js-badge-hint',
                    'data-hint': i18n.t('badges.featured.tooltip') },
                i18n.t('badges.featured.caption')
            );
            break;
        case BADGE_CASES.CHOICE:
            badge = external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                dist["Status"],
                { classes: 'quality-choice' },
                i18n.t('badges.fiverrs_choice.caption')
            );
            break;
        case 'now':
            badge = external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                dist["Status"],
                { classes: 'available-now badge-hint js-badge-hint',
                    'data-hint': i18n.t('badges.available_now.tooltip') },
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('i', null),
                ' ',
                i18n.t('badges.available_now.caption')
            );
            break;
        case BADGE_CASES.PRO:
            badge = external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('span', { className: 'pro-badge card-badge outline badge-hint js-badge-hint', 'data-hint': i18n.t('badges.pro.tooltip') });
            break;
        case BADGE_CASES.LIMITED:
            leftAlign = true;
            badge = external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                dist["Status"],
                { classes: 'limited-edition badge-hint js-badge-hint',
                    'data-hint': i18n.t('badges.limited_edition.tooltip') },
                i18n.t('badges.limited_edition.caption')
            );
            break;
        case BADGE_CASES.HIGH_COMPLETION:
            badge = external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                dist["Status"],
                { classes: 'high-completion-rate badge-hint js-badge-hint',
                    'data-hint': i18n.t('badges.very_reliable.tooltip') },
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('i', null),
                ' ',
                i18n.t('badges.very_reliable.caption')
            );
            break;
        case BADGE_CASES.TALENT:
            leftAlign = true;
            badge = external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                dist["Status"],
                { classes: 'rising-talent badge-hint js-badge-hint',
                    'data-hint': i18n.t('badges.rising_talent.tooltip') },
                i18n.t('badges.rising_talent.caption')
            );
            break;
        default:
            break;
    }

    var classes = ['gig-badge'];
    className && classes.push(className);
    leftAlign && classes.push('left');
    type === BADGE_CASES.TALENT && classes.push('rising-talent');

    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'span',
        { className: classes.join(' ') },
        badge
    );
};

badge_Badge.propTypes = {
    type: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string
};

/* harmony default export */ var shared_badge = (badge_Badge);
// EXTERNAL MODULE: ./src/shared/countdown/style.scss
var countdown_style = __webpack_require__("WOeT");
var countdown_style_default = /*#__PURE__*/__webpack_require__.n(countdown_style);

// CONCATENATED MODULE: ./src/shared/countdown/index.js




var countdown_Countdown = function Countdown(_ref) {
    var deadline = _ref.deadline;

    var now = new Date(),
        deadlineArr = deadline.split(/[- : T]/).map(function (datePiece) {
        return parseInt(datePiece, 10);
    }),
        endDate = new Date(deadlineArr[0], deadlineArr[1] - 1, deadlineArr[2], deadlineArr[3], deadlineArr[4], deadlineArr[5]).getTime(),
        t = endDate - now,
        hoursLeft = Math.floor(t / (1000 * 60 * 60) % 24),
        daysLeft = Math.floor(t / (1000 * 60 * 60 * 24));

    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'span',
        { className: 'countdown' },
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('i', { className: 'fa fa-clock-o' }),
        ' ',
        daysLeft + 'd ' + hoursLeft + 'h'
    );
};

countdown_Countdown.propTypes = {
    deadline: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string
};

/* harmony default export */ var countdown = (countdown_Countdown);
// CONCATENATED MODULE: ./src/shared/gig_badges/index.js
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();






var gig_badges_GigBadges = function GigBadges(props) {
    var badges = [],
        badgeMatrix = [[external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(shared_badge, { key: props.gigId + '_badge_limited', type: 'limited' }), props.limitedEdition], [external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(shared_badge, { key: props.gigId + '_badge_talent', type: 'talent' }), props.risingTalent], [external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(shared_badge, { key: props.gigId + '_badge_high_completion', className: 'high-completion', type: 'high_completion' }), props.reliable], [external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(shared_badge, { key: props.gigId + '_badge_featured', type: 'featured' }), props.featured], [external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(shared_badge, { key: props.gigId + '_badge_choice', type: 'choice' }), props.qualityChoice], [external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(shared_badge, { key: props.gigId + '_badge_now', type: 'now', seller: props.sellerName }), props.availableNow]],
        badge = badgeMatrix.find(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            badgeComponent = _ref2[0],
            condition = _ref2[1];

        return condition;
    }); // eslint-disable-line no-unused-vars

    badge && badges.push(badge[0]);
    props.limitedEdition && badges.push(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(countdown, { key: props.gigId + '_countdown', deadline: props.limitedEditionDeadline }));
    props.pro && badges.push(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(shared_badge, { key: props.gigId + '_badge_pro', type: 'pro' }));

    return badges.length ? external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'span',
        { className: 'gig-badge-container' },
        badges
    ) : null;
};

gig_badges_GigBadges.propTypes = {
    featured: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool,
    limitedEdition: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool,
    limitedEditionDeadline: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    qualityChoice: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool,
    reliable: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool,
    availableNow: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool,
    risingTalent: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool,
    sellerName: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    pro: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool,
    gigId: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.oneOfType([external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string, external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.number])
};

/* harmony default export */ var gig_badges = (gig_badges_GigBadges);
// CONCATENATED MODULE: ./src/utils/tracking.js
var EVENTS = {
    CLICK: 'click'
},
    CARD_TYPES = {
    CARD: 'card',
    LIST: 'list'
},
    CARD_SIZES = {
    MEDIUM: 'medium',
    LARGE: 'large'
},
    PLATFORMS = {
    MIXPANEL: 'mixpanel',
    GRAPHITE: 'graphite',
    BIGQUERY: 'bigquery'
};

function reportToGraphite(evt) {
    var cardType = evt.cardType === 'card' ? evt.cardSize + '_' + evt.cardType : evt.cardType;
    var data = {
        label: 'fe_events.react_' + cardType + '.' + evt.name,
        percentage: evt.percentage || 100
    };

    if (evt.timing) {
        data.timing = evt.timing;
    }

    if (typeof Fiverr !== 'undefined' && Fiverr._logEventToGraphite) {
        Fiverr._logEventToGraphite(data);
    } else {
        console && console.log('Sandbox Graphite logging', data); // eslint-disable-line
    }
}

function reportToMixpanel(evt, dontIgnore) {
    if (dontIgnore) {
        // temporary
        if (typeof MixpanelWrapper !== 'undefined') {
            MixpanelWrapper.trackEvent(MixpanelWrapper.Events.GigCardEvents.CLICKED_CARD, evt.payload);
        } else {
            console && console.log('Sandbox Mixpanel logging', evt.payload); // eslint-disable-line
        }
    }
}

function reportToBigquery(evt) {
    var currentPage = document && document.pageScope && document.pageScope.main || '';
    var data = {
        type: evt.name,
        current_page_type: currentPage
    };

    data = Object.assign(evt.payload, data);

    if (typeof Fiverr.sendClientEvents === 'undefined') {
        console && console.log('Sandbox BigQuery logging', data); // eslint-disable-line
        return;
    }

    Fiverr.sendClientEvents(data);
}

function prepareEventData(eventName, cardType, cardSize, eventType, payload, platform) {
    var evt = {
        name: eventName,
        type: eventType || EVENTS.CLICK,
        cardType: cardType,
        payload: payload || {},
        platform: platform || null
    };

    evt.payload.Subcategory = Fiverr && Fiverr.models && Fiverr.models.ps.subCatName || 'search';
    evt.payload['Click Location'] = evt.name;
    evt.payload['Card Type'] = cardType;
    evt.payload['Card Size'] = cardSize;

    return evt;
}

function trackTime(eventName, startTime) {
    var cardType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : CARD_TYPES.CARD;

    var evt = {
        name: eventName,
        cardType: cardType,
        timing: Date.now() - startTime,
        percentage: 20
    };

    if (evt.timing) {
        reportToGraphite(evt);
    }
}

function trackEvent(eventName) {
    var cardType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CARD_TYPES.CARD;
    var cardSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : CARD_SIZES.MEDIUM;
    var eventType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : EVENTS.CLICK;
    var payload = arguments[4];
    var platform = arguments[5];

    var evt = prepareEventData(eventName, cardType, cardSize, eventType, payload, platform);

    if (!evt.name) {
        return;
    }

    switch (platform) {
        case PLATFORMS.GRAPHITE:
            reportToGraphite(evt);
            break;
        case PLATFORMS.MIXPANEL:
            reportToMixpanel(evt);
            break;
        case PLATFORMS.BIGQUERY:
            reportToBigquery(evt);
            break;
        default:
            reportToMixpanel(evt);
            reportToGraphite(evt);
            break;
    }
}
// CONCATENATED MODULE: ./src/context/createEmitter.js


/* harmony default export */ var createEmitter = (function (value) {
    var subscribers = [];

    var getValue = function getValue() {
        return value;
    },
        publish = function publish(nextValue) {
        value = nextValue;

        subscribers.forEach(function (cb) {
            return cb(_.cloneDeep(value));
        });
    },
        subscribe = function subscribe(callback) {
        subscribers.push(callback);

        return function () {
            return subscribers = subscribers.filter(function (cb) {
                return cb !== callback;
            });
        };
    };

    return { getValue: getValue, publish: publish, subscribe: subscribe };
});
// CONCATENATED MODULE: ./src/context/index.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






function createContext(initialValue) {
    var contextProp = _.uniqueId('_react_context_');

    var ContextProvider = function (_PureComponent) {
        _inherits(ContextProvider, _PureComponent);

        function ContextProvider(props) {
            _classCallCheck(this, ContextProvider);

            var _this = _possibleConstructorReturn(this, (ContextProvider.__proto__ || Object.getPrototypeOf(ContextProvider)).call(this, props));

            _this.emitter = createEmitter(_this.props.value);
            return _this;
        }

        _createClass(ContextProvider, [{
            key: 'getChildContext',
            value: function getChildContext() {
                return _defineProperty({}, contextProp, this.emitter);
            }
        }, {
            key: 'componentDidUpdate',
            value: function componentDidUpdate() {
                var value = this.props.value;


                this.emitter.publish(value);
            }
        }, {
            key: 'render',
            value: function render() {
                var children = this.props.children;

                return children ? children : null;
            }
        }]);

        return ContextProvider;
    }(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__["PureComponent"]);

    ContextProvider.childContextTypes = _defineProperty({}, contextProp, external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.object);

    ContextProvider.defaultProps = {
        value: initialValue
    };

    ContextProvider.propTypes = {
        children: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.element,
        value: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.any
    };

    var ContextConsumer = function (_PureComponent2) {
        _inherits(ContextConsumer, _PureComponent2);

        function ContextConsumer(props, context) {
            _classCallCheck(this, ContextConsumer);

            var _this2 = _possibleConstructorReturn(this, (ContextConsumer.__proto__ || Object.getPrototypeOf(ContextConsumer)).call(this, props, context));

            _this2.state = { value: _this2.getValue() };
            return _this2;
        }

        _createClass(ContextConsumer, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
                var _this3 = this;

                if (this.context[contextProp]) {
                    this.unsubscribe = this.context[contextProp].subscribe(function (value) {
                        return _this3.setState({ value: value });
                    });
                }
            }
        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (this.unsubscribe) {
                    this.unsubscribe();
                }
            }
        }, {
            key: 'getValue',
            value: function getValue() {
                return this.context[contextProp] ? this.context[contextProp].getValue() : initialValue;
            }
        }, {
            key: 'render',
            value: function render() {
                var children = this.props.children;

                return typeof children === 'function' ? children(this.state.value) : null;
            }
        }]);

        return ContextConsumer;
    }(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__["PureComponent"]);

    ContextConsumer.contextTypes = _defineProperty({}, contextProp, external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.object);

    ContextConsumer.propTypes = {
        children: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.func
    };

    return { ContextProvider: ContextProvider, ContextConsumer: ContextConsumer };
}
// CONCATENATED MODULE: ./src/shared/gig_card_context/index.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var _createContext = createContext({ cardType: 'card' }),
    gig_card_context_ContextProvider = _createContext.ContextProvider,
    gig_card_context_ContextConsumer = _createContext.ContextConsumer;

var gig_card_context_GigCardContextProvider = function GigCardContextProvider(_ref) {
    var value = _ref.value,
        children = _ref.children;
    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        gig_card_context_ContextProvider,
        { value: value },
        children
    );
};

var gig_card_context_withGigCardContext = function withGigCardContext(selector) {
    return function (Wrapped) {
        return function (props) {
            return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                gig_card_context_ContextConsumer,
                null,
                function (context) {
                    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(Wrapped, _extends({}, selector(context), props));
                }
            );
        };
    };
};
// EXTERNAL MODULE: ./src/shared/collect_gig/collection_popup/style.scss
var collection_popup_style = __webpack_require__("HK0U");
var collection_popup_style_default = /*#__PURE__*/__webpack_require__.n(collection_popup_style);

// CONCATENATED MODULE: ./src/shared/collect_gig/collection_popup/index.js
var collection_popup__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function collection_popup__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function collection_popup__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function collection_popup__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var collection_popup_CollectionPopup = function (_PureComponent) {
    collection_popup__inherits(CollectionPopup, _PureComponent);

    function CollectionPopup(props) {
        collection_popup__classCallCheck(this, CollectionPopup);

        var _this = collection_popup__possibleConstructorReturn(this, (CollectionPopup.__proto__ || Object.getPrototypeOf(CollectionPopup)).call(this, props));

        _this.state = {
            collectionValue: '',
            withError: false,
            errorMsg: i18n.t('general.went_wrong')
        };

        _this.collectionChange = _this.collectionChange.bind(_this);
        _this.collectionSubmit = _this.collectionSubmit.bind(_this);
        return _this;
    }

    collection_popup__createClass(CollectionPopup, [{
        key: 'collectionChange',
        value: function collectionChange(e) {
            this.setState({
                collectionValue: e.target.value
            });
        }
    }, {
        key: 'collectionSubmit',
        value: function collectionSubmit(e) {
            var _this2 = this;

            e.preventDefault();

            var newCollection = this.state.collectionValue,
                _props = this.props,
                gigId = _props.gigId,
                popupCallback = _props.popupCallback,
                sellerId = _props.sellerId,
                user = _props.user,
                collectionLimits = {
                min: 5,
                max: 52
            };


            if (newCollection.length >= collectionLimits.min && newCollection.length <= collectionLimits.max) {
                this.setState({
                    withError: false
                });

                this.props.saveCollection(gigId, newCollection).then(function () {
                    popupCallback(e);

                    var payload = {
                        collection: {
                            type: 'gig',
                            source: 'gig_card',
                            name: newCollection
                        },
                        user: {
                            id: user.userId
                        },
                        seller: {
                            id: sellerId
                        },
                        gig: {
                            id: gigId
                        }
                    };

                    trackEvent('collections_list-created', _this2.props.cardType, _this2.props.cardSize);
                    trackEvent('collections.create', _this2.props.cardType, _this2.props.cardSize, 'click', payload, 'bigquery');
                }).catch(function (ajaxResp) {
                    _this2.setState({
                        withError: true,
                        errorMsg: ajaxResp || i18n.t('collections.errors.went_wrong')
                    });
                });
            } else {
                this.setState({
                    withError: true,
                    errorMsg: i18n.t('collections.errors.length_error')
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var popupCallback = this.props.popupCallback,
                _state = this.state,
                collectionValue = _state.collectionValue,
                withError = _state.withError,
                errorMsg = _state.errorMsg;


            return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'div',
                { className: 'gig-fav-popup' },
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('div', { className: 'behind', onClick: function onClick(e) {
                        return popupCallback(e);
                    } }),
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'aside',
                    { className: 'modal popup-base' },
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                        'header',
                        null,
                        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                            'a',
                            { href: '#',
                                className: 'btn-close',
                                rel: 'noindex, nofollow',
                                onClick: function onClick(e) {
                                    return popupCallback(e);
                                } },
                            '\xD7'
                        ),
                        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                            'h2',
                            { className: 'cap' },
                            i18n.t('collections.errors.name_new_coll')
                        )
                    ),
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                        'form',
                        { className: 'new-coll-form general-form-field-wrap', onSubmit: this.collectionSubmit },
                        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                            'div',
                            { className: 'popup-content' },
                            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('input', { type: 'text',
                                name: 'collection',
                                id: 'collection',
                                placeholder: i18n.t('collections.errors.collection_name'),
                                onChange: this.collectionChange,
                                value: collectionValue,
                                className: withError ? 'with-error' : '' }),
                            withError && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                                'div',
                                { className: 'error-container' },
                                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                                    'p',
                                    { className: 'msg-error' },
                                    errorMsg
                                )
                            )
                        ),
                        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                            'footer',
                            null,
                            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('input', { type: 'submit',
                                className: 'btn-standard btn-green-grad',
                                value: i18n.t('general.ok') })
                        )
                    )
                )
            );
        }
    }]);

    return CollectionPopup;
}(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__["PureComponent"]);

collection_popup_CollectionPopup.propTypes = {
    gigId: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    popupCallback: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.func,
    saveCollection: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.func
};

var contextSelector = function contextSelector(_ref) {
    var user = _ref.user;
    return { user: user };
};



/* harmony default export */ var collection_popup = (gig_card_context_withGigCardContext(contextSelector)(collection_popup_CollectionPopup));
// EXTERNAL MODULE: ./src/shared/collect_gig/collection_menu/style.scss
var collection_menu_style = __webpack_require__("UCFI");
var collection_menu_style_default = /*#__PURE__*/__webpack_require__.n(collection_menu_style);

// CONCATENATED MODULE: ./src/shared/collect_gig/collection_menu/index.js
var collection_menu__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function collection_menu__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function collection_menu__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function collection_menu__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var collection_menu_CollectionMenu = function (_PureComponent) {
    collection_menu__inherits(CollectionMenu, _PureComponent);

    function CollectionMenu(props) {
        collection_menu__classCallCheck(this, CollectionMenu);

        var _this = collection_menu__possibleConstructorReturn(this, (CollectionMenu.__proto__ || Object.getPrototypeOf(CollectionMenu)).call(this, props));

        _this.state = {
            showPopup: false
        };

        _this.togglePopup = _this.togglePopup.bind(_this);
        _this.onCollectionClicked = _this.onCollectionClicked.bind(_this);
        _this.startTime = Date.now();
        return _this;
    }

    collection_menu__createClass(CollectionMenu, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            trackTime('collection-menu-component-did-mount', this.startTime, this.props.cardType);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            trackTime('collect-menu-component-will-unmount', this.startTime, this.props.cardType);
        }
    }, {
        key: 'togglePopup',
        value: function togglePopup(e) {
            e.preventDefault();

            this.setState({
                showPopup: !this.state.showPopup
            });

            this.state.showPopup && trackEvent('collections_list-open', this.props.cardType, this.props.cardSize);
        }
    }, {
        key: 'onCollectionClicked',
        value: function onCollectionClicked(e, coll, isCollected) {
            var payload = {
                collection: {
                    type: 'gig',
                    source: 'gig_card',
                    name: coll
                },
                user: {
                    id: this.props.user.id
                },
                seller: {
                    id: this.props.sellerId
                },
                gig: {
                    id: this.props.gigId
                }

            };

            trackEvent('collections_list-' + (!isCollected ? 'collected' : 'uncollected'), this.props.cardType, this.props.cardSize);
            trackEvent('collections_list.' + (!isCollected ? 'create' : 'destroy'), this.props.cardType, this.props.cardSize, 'click', payload, 'bigquery');

            this.props.toggleCollection(e, coll, isCollected);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                gigId = _props.gigId,
                cardType = _props.cardType,
                cardSize = _props.cardSize,
                saveCollection = _props.saveCollection,
                collections = _props.collections,
                sellerId = _props.sellerId,
                showPopup = this.state.showPopup,
                collectionsList = collections.collections || {},
                collKeys = Object.keys(collectionsList);


            return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'div',
                { className: 'gig-fav-menu' },
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'div',
                    { className: 'collection-dd coll-dd-4gig open', 'data-gig-id': gigId },
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                        'div',
                        { className: 'antiscroll-wrap' },
                        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                            'ul',
                            { className: 'antiscroll-inner coll-dd-list' },
                            collKeys.length && collKeys.map(function (coll) {
                                var isCollected = collectionsList[coll].gigs.includes(gigId);
                                return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                                    'li',
                                    { className: 'coll-dd-item', key: coll },
                                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                                        'a',
                                        { href: '#',
                                            className: 'heart' + (isCollected ? ' collected' : ''),
                                            onClick: function onClick(e) {
                                                return _this2.onCollectionClicked(e, coll, isCollected);
                                            } },
                                        coll
                                    )
                                );
                            })
                        )
                    ),
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                        'ul',
                        null,
                        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('li', { className: 'divider' }),
                        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                            'li',
                            null,
                            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                                'a',
                                { href: '#!',
                                    className: 'add-coll',
                                    onClick: function onClick(e) {
                                        return _this2.togglePopup(e);
                                    } },
                                i18n.t('collections.add_collection')
                            )
                        )
                    )
                ),
                showPopup && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(collection_popup, { gigId: gigId, sellerId: sellerId, saveCollection: saveCollection, popupCallback: this.togglePopup, cardType: cardType, cardSize: cardSize })
            );
        }
    }]);

    return CollectionMenu;
}(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__["PureComponent"]);

collection_menu_CollectionMenu.propTypes = {
    gigId: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    collections: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.oneOfType([external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.object, external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool]),
    cardType: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    saveCollection: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.func,
    toggleCollection: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.func
};

var collection_menu_contextSelector = function contextSelector(_ref) {
    var user = _ref.user;
    return { user: user };
};



/* harmony default export */ var collection_menu = (gig_card_context_withGigCardContext(collection_menu_contextSelector)(collection_menu_CollectionMenu));
// EXTERNAL MODULE: ./src/shared/collect_gig/collection/style.scss
var collection_style = __webpack_require__("rD3X");
var collection_style_default = /*#__PURE__*/__webpack_require__.n(collection_style);

// CONCATENATED MODULE: ./src/shared/collect_gig/collection/index.js
var collection__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function collection__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function collection__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function collection__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var collection_Collection = function (_PureComponent) {
    collection__inherits(Collection, _PureComponent);

    function Collection(props) {
        collection__classCallCheck(this, Collection);

        var _this = collection__possibleConstructorReturn(this, (Collection.__proto__ || Object.getPrototypeOf(Collection)).call(this, props));

        _this.state = {
            showCollections: false,
            clickCameFromComponent: false
        };

        _this.toggleCollections = _this.toggleCollections.bind(_this);
        _this.turnOffCollectionsMenu = _this.turnOffCollectionsMenu.bind(_this);
        _this.startTime = Date.now();
        return _this;
    }

    collection__createClass(Collection, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            document.body.addEventListener('mousedown', this.turnOffCollectionsMenu);
            trackTime('collection-component-did-mount', this.startTime, this.props.cardType);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.body.removeEventListener('mousedown', this.turnOffCollectionsMenu);
            trackTime('collection-component-will-unmount', this.startTime, this.props.cardType);
        }
    }, {
        key: 'turnOffCollectionsMenu',
        value: function turnOffCollectionsMenu() {
            if (!this.state.showCollections || !(this.collRef && !this.collRef.contains(event.target))) {
                return false;
            }

            this.setState({
                showCollections: false
            });
        }
    }, {
        key: 'toggleCollections',
        value: function toggleCollections(e) {
            e.preventDefault();

            this.setState({
                showCollections: !this.state.showCollections
            });

            trackEvent('collections_list', this.props.cardType, this.props.cardSize);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                gigId = _props.gigId,
                cardType = _props.cardType,
                icon = _props.icon,
                hintClass = cardType === 'list' ? 'hint--bottom-right' : 'hint--top',
                showCollections = this.state.showCollections;


            return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'span',
                { className: 'coll-group', ref: function ref(_ref) {
                        _this2.collRef = _ref;
                    } },
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'a',
                    { className: 'icn-heart-toggle ' + hintClass,
                        href: '#!',
                        'data-hint': i18n.t('collections.save_in'),
                        'data-coll-gig': 'coll-gig-' + gigId,
                        'data-gtm-action': 'hp-clicked-list',
                        'data-gtm-event': 'collections',
                        onClick: function onClick(e) {
                            return _this2.toggleCollections(e);
                        } },
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('i', { className: icon })
                ),
                showCollections && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(collection_menu, this.props)
            );
        }
    }]);

    return Collection;
}(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__["PureComponent"]);

collection_Collection.propTypes = {
    gigId: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.oneOfType([external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.number, external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string]),
    collections: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.oneOfType([external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.object, external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool]),
    cardType: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    icon: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    saveCollection: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.func,
    toggleCollection: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.func
};

/* harmony default export */ var collect_gig_collection = (collection_Collection);
// EXTERNAL MODULE: ./src/shared/collect_gig/favorite/style.scss
var favorite_style = __webpack_require__("ijbM");
var favorite_style_default = /*#__PURE__*/__webpack_require__.n(favorite_style);

// CONCATENATED MODULE: ./src/shared/collect_gig/favorite/index.js
var favorite__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var favorite_Favorite = function Favorite(_ref) {
    var isFavorited = _ref.isFavorited,
        user = _ref.user,
        toggleCollection = _ref.toggleCollection,
        cardType = _ref.cardType,
        cardSize = _ref.cardSize,
        gigId = _ref.gigId,
        sellerId = _ref.sellerId;

    var heartColor = isFavorited ? ' red' : '',
        hintClassTrue = cardType === 'list' ? 'hint--bottom-right ' : 'hint--top ',
        hintClass = !isFavorited ? hintClassTrue : '',
        hintText = !isFavorited ? i18n.t('collections.add_to_favorites') : null,
        onClick = function onClick(e) {
        var payload = {
            collection: {
                type: 'gig',
                source: 'gig_card',
                name: 'Gigs I Love'
            },
            user: {
                id: user.userId
            },
            seller: {
                id: sellerId
            },
            gig: {
                id: gigId
            }
        };

        trackEvent('heart-' + (!isFavorited ? 'collect' : 'uncollect'), cardType, cardSize);
        trackEvent('collection_items.' + (!isFavorited ? 'create' : 'destroy'), cardType, cardSize, 'click', payload, 'bigquery');

        toggleCollection(e, 'Gigs I Love', isFavorited);
    };

    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'a',
        favorite__extends({ className: hintClass + 'icn-heart' + (user ? '' : ' js-open-popup-join'),
            href: '#!'
        }, hintText && { 'data-hint': hintText }, {
            'data-gtm-action': 'hp-clicked-heart',
            'data-gtm-event': 'collections',
            onClick: onClick }),
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('i', { className: 'ficon ficon-favorite' + heartColor })
    );
};

favorite_Favorite.propTypes = {
    isFavorited: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool,
    cardType: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    user: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.object,
    toggleCollection: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.func
};

/* harmony default export */ var favorite = (favorite_Favorite);
// EXTERNAL MODULE: ./src/shared/collect_gig/style.scss
var collect_gig_style = __webpack_require__("ZpHc");
var collect_gig_style_default = /*#__PURE__*/__webpack_require__.n(collect_gig_style);

// CONCATENATED MODULE: ./src/shared/collect_gig/index.js
var collect_gig__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function collect_gig__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function collect_gig__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function collect_gig__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function collect_gig__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










// constants
var gigsIloveKey = 'Gigs I Love',
    collectionDefault = { gigs: [], active: true },
    collectionsListDefault = collect_gig__defineProperty({}, gigsIloveKey, collectionDefault);

var collect_gig_CollectGig = function (_Component) {
    collect_gig__inherits(CollectGig, _Component);

    function CollectGig(props) {
        collect_gig__classCallCheck(this, CollectGig);

        var _this = collect_gig__possibleConstructorReturn(this, (CollectGig.__proto__ || Object.getPrototypeOf(CollectGig)).call(this, props));

        _this.saveCollection = _this.saveCollection.bind(_this);
        _this.toggleCollection = _this.toggleCollection.bind(_this);

        _this.startTime = Date.now();
        return _this;
    }

    collect_gig__createClass(CollectGig, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            trackTime('collect-gig-component-did-mount', this.startTime, this.props.cardType);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            trackTime('collect-gig-component-will-unmount', this.startTime, this.props.cardType);
        }
    }, {
        key: 'toggleCollection',
        value: function toggleCollection(e, coll, isCollected) {
            var _this2 = this;

            e.preventDefault();

            var newValue = !isCollected,
                ajaxType = newValue ? 'POST' : 'DELETE',
                _props = this.props,
                collections = _props.collections,
                gigId = _props.gigId,
                collectionsList = collections ? collections.collections : collectionsListDefault;


            return collection.toggleFavorite(ajaxType, gigId, coll).then(function (resp) {
                if (resp === 'success') {
                    var collection = collectionsList[coll] || collectionDefault;

                    if (newValue) {
                        collection.gigs.push(gigId);
                    } else {
                        collection.gigs = collection.gigs.filter(function (id) {
                            return id !== gigId;
                        });
                    }

                    var nextCollections = Object.assign({}, collectionsList, collect_gig__defineProperty({}, coll, collection));

                    _this2.props.updateCollections({ collections: nextCollections });
                }
            });
        }
    }, {
        key: 'saveCollection',
        value: function saveCollection(gigId, collectionKey) {
            var _this3 = this;

            return collection.newCollection(gigId, collectionKey).then(function (ajaxResp) {
                if (ajaxResp === 'success') {
                    var newCollection = collect_gig__defineProperty({}, collectionKey, {
                        gigs: [gigId],
                        active: true
                    }),
                        collections = _this3.props.collections.collections;

                    _this3.props.updateCollections({ collections: Object.assign({}, collections, newCollection) });
                }
            });
        }
    }, {
        key: 'checkIsFavorited',
        value: function checkIsFavorited(gigId, collectionsList) {
            if (!this.props.user || !collectionsList) {
                return false;
            }

            var collections = collectionsList.collections;

            return Object.keys(collections).length ? collections[gigsIloveKey].gigs.includes(gigId) : false;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                gigId = _props2.gigId,
                user = _props2.user,
                showCollMenu = _props2.showCollMenu,
                cardType = _props2.cardType,
                cardSize = _props2.cardSize,
                icon = _props2.icon,
                collections = _props2.collections,
                sellerId = _props2.sellerId,
                isFavorited = this.checkIsFavorited(gigId, collections),
                shouldShowCollMenu = !!(user && showCollMenu);


            return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'div',
                { className: 'gig-fav' },
                shouldShowCollMenu && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(collect_gig_collection, { gigId: gigId, sellerId: sellerId, collections: collections, saveCollection: this.saveCollection, toggleCollection: this.toggleCollection, icon: icon, cardType: cardType, cardSize: cardSize }),
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(favorite, { isFavorited: isFavorited, gigId: gigId, sellerId: sellerId, collections: collections, user: user, toggleCollection: this.toggleCollection, cardType: cardType, cardSize: cardSize })
            );
        }
    }]);

    return CollectGig;
}(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__["Component"]);

collect_gig_CollectGig.propTypes = {
    collections: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.oneOfType([external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.object, external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool]),
    gigId: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.oneOfType([external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.number, external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string]),
    user: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.object,
    showCollMenu: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool,
    cardType: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    icon: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    updateCollections: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.func
};

var collect_gig_contextSelector = function contextSelector(_ref) {
    var cardType = _ref.cardType,
        cardSize = _ref.cardSize,
        collections = _ref.collections;
    return { cardType: cardType, cardSize: cardSize, collections: collections };
};

/* harmony default export */ var collect_gig = (gig_card_context_withGigCardContext(collect_gig_contextSelector)(collect_gig_CollectGig));
// EXTERNAL MODULE: ./src/shared/card_shell/style.scss
var card_shell_style = __webpack_require__("NYAQ");
var card_shell_style_default = /*#__PURE__*/__webpack_require__.n(card_shell_style);

// CONCATENATED MODULE: ./src/shared/card_shell/index.js




var card_shell_GigCardShell = function GigCardShell(_ref) {
    var type = _ref.type,
        gigId = _ref.gigId,
        wrapperCls = _ref.wrapperCls,
        children = _ref.children;

    var classes = ['gig-card-base', 'slide', type, 'js-gig-card', 'js-slide'];
    wrapperCls && classes.push(wrapperCls);

    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'div',
        { 'data-gig-id': gigId, className: classes.join(' ') },
        children
    );
};

card_shell_GigCardShell.propTypes = {
    wrapperCls: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    gigId: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.number,
    type: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    children: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.any
};

/* harmony default export */ var card_shell = (card_shell_GigCardShell);
// CONCATENATED MODULE: ./src/shared/seller_delivery_time/index.js




var seller_delivery_time_SellerDeliveryTime = function SellerDeliveryTime(_ref) {
    var deliveryTime = _ref.deliveryTime;
    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'p',
        { className: 'seller-delivery-time' },
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'span',
            null,
            'Average Delivery:'
        ),
        ' ',
        deliveryTime,
        ' ',
        i18n.t('general.day'),
        deliveryTime !== 1 && 's'
    );
};

seller_delivery_time_SellerDeliveryTime.propTypes = {
    deliveryTime: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.number
};

/* harmony default export */ var seller_delivery_time = (seller_delivery_time_SellerDeliveryTime);
// EXTERNAL MODULE: ./src/shared/list_view_info/style.scss
var list_view_info_style = __webpack_require__("xZmo");
var list_view_info_style_default = /*#__PURE__*/__webpack_require__.n(list_view_info_style);

// CONCATENATED MODULE: ./src/shared/list_view_info/index.js
var list_view_info__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function list_view_info__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function list_view_info__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function list_view_info__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var list_view_info_ListViewInfo = function (_PureComponent) {
    list_view_info__inherits(ListViewInfo, _PureComponent);

    function ListViewInfo(props) {
        list_view_info__classCallCheck(this, ListViewInfo);

        var _this = list_view_info__possibleConstructorReturn(this, (ListViewInfo.__proto__ || Object.getPrototypeOf(ListViewInfo)).call(this, props));

        _this.state = {
            platforms: null,
            skills: null
        };

        _this.startTime = Date.now();
        return _this;
    }

    list_view_info__createClass(ListViewInfo, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var platforms = this.props.platforms && this.props.platforms.length ? this.props.platforms.join(', ') : null,
                skills = this.props.skills && this.props.skills.length ? this.props.skills.slice(0, 4).join(', ') : null;

            if (!platforms && !skills) {
                return;
            }

            this.setState({ platforms: platforms, skills: skills });
            trackTime('list-view-info-component-will-mount', this.startTime, this.props.cardType);
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            trackTime('list-view-info-component-did-mount', this.startTime, this.props.cardType);
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                platforms = _state.platforms,
                skills = _state.skills,
                avgDeliveryTime = this.props.avgDeliveryTime;


            return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'div',
                { className: 'list-view-info' },
                platforms && platforms.length ? external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'p',
                    null,
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                        'span',
                        null,
                        'Platform:'
                    ),
                    ' ',
                    platforms
                ) : null,
                skills && skills.length ? external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'p',
                    null,
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                        'span',
                        null,
                        'Expertise:'
                    ),
                    ' ',
                    skills
                ) : null,
                avgDeliveryTime ? external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(seller_delivery_time, { deliveryTime: avgDeliveryTime }) : null
            );
        }
    }]);

    return ListViewInfo;
}(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__["PureComponent"]);

list_view_info_ListViewInfo.propTypes = {
    cardType: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    platforms: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.array,
    skills: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.array,
    avgDeliveryTime: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string
};

/* harmony default export */ var list_view_info = (list_view_info_ListViewInfo);
// EXTERNAL MODULE: ./src/shared/media/thumbnail/style.scss
var thumbnail_style = __webpack_require__("svXm");
var thumbnail_style_default = /*#__PURE__*/__webpack_require__.n(thumbnail_style);

// CONCATENATED MODULE: ./src/shared/media/thumbnail/index.js





var thumbnail_Thumbnail = function Thumbnail(_ref) {
    var src = _ref.src,
        srcSet = _ref.srcSet,
        cardType = _ref.cardType,
        cardSize = _ref.cardSize;
    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('img', { src: src, srcSet: srcSet, className: 'gig-thumbnail', onClick: function onClick() {
            return trackEvent('thumbnail', cardType, cardSize);
        } });
};

thumbnail_Thumbnail.propTypes = {
    src: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    cardType: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string
};

/* harmony default export */ var thumbnail = (thumbnail_Thumbnail);
// EXTERNAL MODULE: ./src/shared/media/slider/style.scss
var slider_style = __webpack_require__("eLcb");
var slider_style_default = /*#__PURE__*/__webpack_require__.n(slider_style);

// EXTERNAL MODULE: ./src/shared/media/slider/arrow/style.scss
var arrow_style = __webpack_require__("z2GC");
var arrow_style_default = /*#__PURE__*/__webpack_require__.n(arrow_style);

// CONCATENATED MODULE: ./src/shared/media/slider/arrow/index.js




var arrow_Arrow = function Arrow(_ref) {
    var direction = _ref.direction,
        onClick = _ref.onClick;
    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'div',
        { className: 'slider-arrow-wrapper ' + direction + ' active', rel: 'nofollow', onClick: onClick },
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('span', { className: 'arrow' })
    );
};

arrow_Arrow.propTypes = {
    direction: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string
};

/* harmony default export */ var arrow = (arrow_Arrow);
// CONCATENATED MODULE: ./src/utils/eventBus.js
var events = {};

function subscribe(evt, callback) {
    if (!events[evt]) {
        events[evt] = {
            listeners: []
        };
    }

    if (typeof callback === 'function') {
        events[evt].listeners.push(callback);
    }
}

function unsubscribe(evt, callback) {
    var foundIndex = -1;

    if (events[evt] && events[evt].listeners) {
        for (var i = 0; i < events[evt].listeners.length; i++) {
            if (events[evt].listeners[i] === callback) {
                foundIndex = i;
            }
        }

        if (foundIndex > -1) {
            events[evt].listeners.splice(foundIndex, 1);
        }
    }
}

function publish(evt, payload) {
    if (events[evt] && events[evt].listeners) {
        for (var i = 0; i < events[evt].listeners.length; i++) {
            events[evt].listeners[i](payload);
        }
    }
}
// CONCATENATED MODULE: ./src/shared/media/slider/index.js
var slider__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function slider__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function slider__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function slider__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var slider_Slider = function (_Component) {
    slider__inherits(Slider, _Component);

    function Slider(props) {
        slider__classCallCheck(this, Slider);

        var _this = slider__possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props));

        _this.state = {
            slides: [],
            page: 0
        };

        _this.changeSlide = _this.changeSlide.bind(_this);
        return _this;
    }

    slider__createClass(Slider, [{
        key: 'changeSlide',
        value: function changeSlide(e, direction) {
            e.preventDefault();

            var step = direction === 'next' ? 1 : -1,
                totalPages = this.state.slides.length;

            var currentPage = this.state.page;

            switch (currentPage + step) {
                case -1:
                    currentPage = totalPages - 1;
                    break;
                case totalPages:
                    currentPage = 0;
                    break;
                default:
                    currentPage = currentPage + step;
                    break;
            }

            publish('pauseInternalPlayers', { gigId: this.props.gigId });

            this.setState({
                page: currentPage
            });

            trackEvent('carousel_arrow_' + direction, this.props.cardType, this.props.cardSize);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var slideWidth = this.props.slideWidth || 230;
            this.state.slides = this.props.children; // eslint-disable-line

            var hasSlides = this.state.slides.length > 1;

            return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'div',
                { className: 'media-slider' },
                hasSlides && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(arrow, { direction: 'next', onClick: function onClick(e) {
                        return _this2.changeSlide(e, 'next');
                    } }),
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'div',
                    { className: 'slides', style: { width: this.state.slides.length * slideWidth, transform: 'translateX(-' + slideWidth * this.state.page + 'px)' } },
                    this.props.children
                ),
                hasSlides && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(arrow, { direction: 'prev', onClick: function onClick(e) {
                        return _this2.changeSlide(e, 'prev');
                    } })
            );
        }
    }]);

    return Slider;
}(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__["Component"]);

slider_Slider.propTypes = {
    gigId: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.number,
    children: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.any
};

/* harmony default export */ var slider = (slider_Slider);
// CONCATENATED MODULE: ./src/shared/media/helpers.js
function getImgByCardSize(imageData, cardSize) {
    return cardSize === 'large' ? imageData.cloud_img_lrg : imageData.cloud_img_med_alt;
}

function getImgThumbUrl(img) {
    return img.match(/(src=")([^"]*)(")/g)[0].replace('src=', '').replace(/"/g, '');
}

function getImgSrcSet(img) {
    return img.match(/(srcset=")([^"]*)(")/g)[0].replace('srcset=', '').replace(/"/g, '');
}

function getMediaId(url) {
    return url.match(/\d+/g)[0];
}
// EXTERNAL MODULE: ./src/shared/media/player/style.scss
var player_style = __webpack_require__("ysQM");
var player_style_default = /*#__PURE__*/__webpack_require__.n(player_style);

// CONCATENATED MODULE: ./src/shared/media/player/index.js
var player__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function player__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function player__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function player__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var player_Player = function (_PureComponent) {
    player__inherits(Player, _PureComponent);

    function Player(props) {
        player__classCallCheck(this, Player);

        var _this = player__possibleConstructorReturn(this, (Player.__proto__ || Object.getPrototypeOf(Player)).call(this, props));

        _this.state = {
            isPlaying: false,
            showThumbnail: true,
            isMuted: false,
            progress: '100 100',
            currentPlayer: null
        };

        _this.togglePlaying = _this.togglePlaying.bind(_this);
        _this.play = _this.play.bind(_this);
        _this.pause = _this.pause.bind(_this);
        _this.pauseInternalPlayers = _this.pauseInternalPlayers.bind(_this);
        _this.playerEnded = _this.playerEnded.bind(_this);
        _this.updateVideoProgress = _this.updateVideoProgress.bind(_this);
        _this.startTime = Date.now();
        return _this;
    }

    player__createClass(Player, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            subscribe('pauseAllPlayers', this.pause);
            subscribe('pauseInternalPlayers', this.pauseInternalPlayers);
            this.player.addEventListener('ended', this.playerEnded, false);
            this.player.addEventListener('timeupdate', this.updateVideoProgress, false);
            trackTime('player-component-did-mount', this.startTime, this.props.cardType);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            unsubscribe('pauseAllPlayers', this.pause);
            unsubscribe('pauseInternalPlayers', this.pauseInternalPlayers);
            this.player.removeEventListener('ended', this.playerEnded, false);
            this.player.removeEventListener('timeupdate', this.updateVideoProgress, false);
            trackTime('player-component-did-unmount', this.startTime, this.props.cardType);
        }
    }, {
        key: 'pauseInternalPlayers',
        value: function pauseInternalPlayers(payload) {
            if (payload.gigId === this.props.gigId) {
                this.pause();
            }
        }
    }, {
        key: 'playerEnded',
        value: function playerEnded() {
            this.setState({ isPlaying: false });
        }
    }, {
        key: 'updateVideoProgress',
        value: function updateVideoProgress() {
            var totalPercentage = 2 * 3.14 * 14,
                percentage = this.player.currentTime * totalPercentage / this.player.duration;

            this.setState({ progress: percentage + ' 100' });
        }
    }, {
        key: 'play',
        value: function play() {
            publish('pauseAllPlayers', { gigId: this.props.gigId });

            if (this.props.media.asset_type === 'video') {
                this.setState({ showThumbnail: false });
            }

            this.setState({ isPlaying: true });
            this.player.play();
        }
    }, {
        key: 'pause',
        value: function pause() {
            this.setState({ isPlaying: false });
            this.player.pause();
        }
    }, {
        key: 'togglePlaying',
        value: function togglePlaying(e) {
            e.preventDefault();

            if (this.player.paused) {
                this.play();
                trackEvent('player_play', this.props.cardType, this.props.cardSize);

                // Magisto Video AB Test - BI Report
                this.reportForMagistoTest(this.props.gigId, this.props.userId, this.props.media.seller_id, this.props.cardType, this.props.cardSize);
            } else {
                this.pause();
                trackEvent('player_pause', this.props.cardType, this.props.cardSize);
            }
        }
    }, {
        key: 'reportForMagistoTest',
        value: function reportForMagistoTest(gigId, userId, sellerId, cardType, cardSize) {
            var magistoTestGigList = [97708643, 82072996, 44978164, 44098059, 41298300, 35947280, 31326435, 21001527, 13042844, 3663294],
                payload = { gigId: gigId, userId: userId, sellerId: sellerId, group: 'other',
                user: [{ id: userId, side: 'general' }, { id: sellerId, side: 'seller' }],
                gig: { id: gigId }
            };

            if (magistoTestGigList.indexOf(gigId) === -1) {
                return;
            }
            trackEvent('gig_video.click_play', cardType, cardSize, null, payload, 'bigquery');
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                cardSize = _props.cardSize,
                media = _props.media,
                videoThumb = cardSize === 'large' ? media.video_thumb_lrg : media.video_thumb,
                mediaId = getMediaId(media.video_stream_url);


            return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'div',
                { className: 'media-player ' + cardSize + ' ' + (!this.state.showThumbnail ? 'backdrop' : '') },
                this.state.showThumbnail && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(thumbnail, { src: getImgThumbUrl(videoThumb) }),
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'span',
                    { className: 'gig-video-button-wrapper' },
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('span', { onClick: this.togglePlaying, className: 'gig-video-button ' + (this.state.isPlaying ? 'pause' : 'play') + ' js-gig-video-button', 'data-aux-data': 'new-video-button-was-clicked', 'data-graphite': '{"label": "gig_listing.video.click"}' }),
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                        'svg',
                        { className: 'video-player-progress-wrapper js-video-player-progress-wrapper', viewBox: '-2 -4 40 40' },
                        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('circle', { className: 'circle-progress-bar-background', r: '14', cx: '18', cy: '14' }),
                        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('circle', { style: { strokeDasharray: this.state.progress }, className: 'circle-progress-bar', r: '14', cx: '18', cy: '14' })
                    )
                ),
                media.asset_type === 'video' && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'video',
                    { key: 'player_' + mediaId, id: 'player_' + mediaId, ref: function ref(_ref) {
                            _this2.player = _ref;
                        } },
                    !this.state.showThumbnail && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('source', { src: media.video_stream_url, type: 'video/mp4' })
                ),
                media.asset_type === 'audio' && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'audio',
                    { key: 'player_' + mediaId, id: 'player_' + mediaId, ref: function ref(_ref2) {
                            _this2.player = _ref2;
                        } },
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('source', { src: media.video_stream_url, type: 'audio/mp4' })
                )
            );
        }
    }]);

    return Player;
}(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__["PureComponent"]);

player_Player.propTypes = {
    gigId: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.number,
    cardType: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string
};

/* harmony default export */ var player = (player_Player);
// EXTERNAL MODULE: ./src/shared/media/style.scss
var media_style = __webpack_require__("Repj");
var media_style_default = /*#__PURE__*/__webpack_require__.n(media_style);

// CONCATENATED MODULE: ./src/shared/media/index.js
var media__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function media__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function media__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function media__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var media_Media = function (_PureComponent) {
    media__inherits(Media, _PureComponent);

    function Media(props) {
        media__classCallCheck(this, Media);

        var _this = media__possibleConstructorReturn(this, (Media.__proto__ || Object.getPrototypeOf(Media)).call(this, props));

        _this.state = {
            assets: null,
            loadedAssets: false
        };

        _this.loadAssets = _this.loadAssets.bind(_this);
        _this.getGigItemWidth = _.debounce(_this.getGigItemWidth, 250).bind(_this);
        _this.startTime = Date.now();
        return _this;
    }

    media__createClass(Media, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var assets = this.props.assets;

            this.setState({
                assets: assets
            });

            trackTime('media-component-will-mount', this.startTime, this.props.cardType);
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.addEventListener('resize', this.getGigItemWidth);
            this.getGigItemWidth();

            trackTime('media-component-did-mount', this.startTime, this.props.cardType);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('resize', this.getGigItemWidth);
        }
    }, {
        key: 'getGigItemWidth',
        value: function getGigItemWidth() {
            var _this2 = this;

            var running = false;

            if (!running) {
                running = true;
                window.requestAnimationFrame(function () {
                    return _this2.setSlideWidth(function () {
                        return running = false;
                    });
                });
            }
        }
    }, {
        key: 'setSlideWidth',
        value: function setSlideWidth(callback) {
            var _this3 = this;

            this.setState(function (state) {
                var containerWidth = _this3.mediaContainer.offsetWidth;
                var nextState = state;

                if (state.slideWidth !== containerWidth) {
                    nextState = Object.assign({}, state, { slideWidth: containerWidth });
                }

                return nextState;
            }, callback);
        }
    }, {
        key: 'loadAssets',
        value: function loadAssets() {
            if (this.state.loadedAssets) {
                return;
            }

            var assets = this.state.assets.map(function (asset) {
                return Object.assign({}, asset, { visible: true });
            });

            this.setState({
                assets: assets,
                loadedAssets: true
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var _state = this.state,
                assets = _state.assets,
                slideWidth = _state.slideWidth,
                _props = this.props,
                userId = _props.userId,
                gigId = _props.gigId,
                cardType = _props.cardType,
                cardSize = _props.cardSize;


            if (!assets) {
                return null;
            }

            return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'div',
                { className: 'media-container', ref: function ref(el) {
                        return _this4.mediaContainer = el;
                    }, onMouseEnter: this.loadAssets },
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    slider,
                    { slideWidth: slideWidth, gigId: gigId, cardType: cardType, cardSize: cardSize },
                    assets.map(function (asset, index) {
                        return (index === 0 || asset.visible) && asset.asset_type === 'image' && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                            'div',
                            { key: 'wrapper-' + index + '-' + gigId, style: { 'width': slideWidth + 'px' } },
                            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(thumbnail, { key: 'thumb-' + index + '-' + gigId, src: getImgThumbUrl(getImgByCardSize(asset.image_data, cardSize)), srcSet: getImgSrcSet(getImgByCardSize(asset.image_data, cardSize)), cardType: cardType, cardSize: cardSize })
                        ) || ((index === 0 || asset.visible) && asset.asset_type === 'video' || asset.asset_type === 'audio') && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                            'div',
                            { key: 'wrapper-' + index + '-' + gigId, style: { 'width': slideWidth + 'px' } },
                            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(player, { key: 'player-' + index + '-' + gigId, media: asset, gigId: gigId, cardType: cardType, cardSize: cardSize, userId: userId })
                        );
                    })
                )
            );
        }
    }]);

    return Media;
}(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__["PureComponent"]);

media_Media.propTypes = {
    assets: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.array,
    gigId: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.number,
    cardType: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string
};

var media_contextSelector = function contextSelector(_ref) {
    var cardType = _ref.cardType,
        cardSize = _ref.cardSize;
    return { cardType: cardType, cardSize: cardSize };
};

/* harmony default export */ var shared_media = (gig_card_context_withGigCardContext(media_contextSelector)(media_Media));
// EXTERNAL MODULE: ./src/shared/price/style.scss
var price_style = __webpack_require__("fRv3");
var price_style_default = /*#__PURE__*/__webpack_require__.n(price_style);

// CONCATENATED MODULE: ./src/shared/price/index.js







var price_Price = function Price(_ref) {
    var gigUrl = _ref.gigUrl,
        price = _ref.price,
        cardType = _ref.cardType,
        cardSize = _ref.cardSize,
        _ref$abTests = _ref.abTests,
        abTests = _ref$abTests === undefined ? {} : _ref$abTests,
        averagePrice = _ref.averagePrice,
        medianPrice = _ref.medianPrice,
        showStartingAt = _ref.showStartingAt,
        isLimitedEdition = _ref.isLimitedEdition;

    var classes = ['gig-price'],
        avgMedPriceEnum = {
        2: averagePrice ? i18n.t('price.on_average') + ' ' + averagePrice : null,
        3: medianPrice ? i18n.t('price.most_successful') + ' ' + medianPrice : null
    },
        inAvgMedVariation = avgMedPriceEnum.hasOwnProperty(abTests.AVG_MEDIAN_PRICE_2),
        subPrice = avgMedPriceEnum[abTests.AVG_MEDIAN_PRICE_2];

    var prefix = showStartingAt ? i18n.t('price.starting_at') : '';

    if (isLimitedEdition) {
        prefix = i18n.t('price.only');
    }

    inAvgMedVariation && classes.push('med-avg-price');

    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'div',
        { className: classes.join(' ') },
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'a',
            { href: gigUrl, onClick: function onClick() {
                    return trackEvent('price', cardType, cardSize);
                } },
            prefix && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'small',
                null,
                prefix
            ),
            price,
            subPrice && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'div',
                { className: 'gig-sub-price' },
                subPrice
            )
        )
    );
};

price_Price.propTypes = {
    gigUrl: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string.isRequired,
    price: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.oneOfType([external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string, external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.number]),
    cardType: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    showStartingAt: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool,
    averagePrice: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    medianPrice: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string
};

var price_contextSelector = function contextSelector(_ref2) {
    var cardType = _ref2.cardType,
        cardSize = _ref2.cardSize,
        abTests = _ref2.abTests;
    return { cardType: cardType, cardSize: cardSize, abTests: abTests };
};

/* harmony default export */ var shared_price = (gig_card_context_withGigCardContext(price_contextSelector)(price_Price));
// EXTERNAL MODULE: ./src/shared/rating/style.scss
var rating_style = __webpack_require__("mFR0");
var rating_style_default = /*#__PURE__*/__webpack_require__.n(rating_style);

// CONCATENATED MODULE: ./src/shared/rating/index.js





var VOTES_THRESHOLD = 1000;
var FULL_STAR = 'full_star';
var EMPTY_STAR = 'o_star';
var HALF_STAR = 'o_half_star';

var rating_Rating = function Rating(_ref) {
    var score = _ref.score,
        gigId = _ref.gigId,
        votes = _ref.votes,
        starSize = _ref.starSize,
        starCount = _ref.starCount,
        isPro = _ref.isPro;


    var getVotes = function getVotes() {
        if (votes >= VOTES_THRESHOLD) {
            return '1k+';
        }

        return votes;
    };

    var scoreText = (score / 2).toFixed(1),
        votesText = '(' + getVotes() + ')',
        starsScoreNum = Math.round(parseFloat(scoreText) * 2) / 2,
        starAttrs = {
        icon: FULL_STAR,
        color: 'yellow',
        width: starSize,
        height: starSize
    },
        stars = [],
        isNonRatedProSeller = score <= 0 && isPro,
        showScore = score > 0;

    for (var star = 1; star <= starCount; star++) {
        if (starCount > 1) {
            if (star <= starsScoreNum) {
                starAttrs.icon = FULL_STAR;
            } else if (star > Math.round(starsScoreNum)) {
                starAttrs.icon = EMPTY_STAR;
            } else {
                starAttrs.icon = HALF_STAR;
            }
        }

        starAttrs.key = 'gig-rating-' + gigId;

        stars.push(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(dist["SvgIcon"], starAttrs));
    }

    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'span',
        { className: 'gig-rating' },
        stars,
        isNonRatedProSeller && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'strong',
            null,
            i18n.t('rating.be_the_first_to_rate')
        ),
        showScore && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'span',
            null,
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'strong',
                null,
                scoreText
            ),
            ' ',
            votesText
        )
    );
};

rating_Rating.propTypes = {
    score: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.number,
    votes: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.number
};

/* harmony default export */ var rating = (rating_Rating);
// CONCATENATED MODULE: ./src/shared/seller_country/index.js




var seller_country_SellerCountry = function SellerCountry(_ref) {
    var country = _ref.country,
        comma = _ref.comma;
    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'span',
        { className: 'seller-country' },
        comma ? ', ' : '',
        i18n.t('general.from'),
        ' ',
        country
    );
};

seller_country_SellerCountry.propTypes = {
    country: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    comma: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool
};

/* harmony default export */ var seller_country = (seller_country_SellerCountry);
// EXTERNAL MODULE: ./src/shared/seller_info/style.scss
var seller_info_style = __webpack_require__("LlhT");
var seller_info_style_default = /*#__PURE__*/__webpack_require__.n(seller_info_style);

// CONCATENATED MODULE: ./src/shared/seller_info/index.js




var seller_info_SellerInfo = function SellerInfo(_ref) {
    var children = _ref.children;
    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'div',
        { className: 'gig-seller-info' },
        children
    );
};

seller_info_SellerInfo.propTypes = {
    children: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.arrayOf(external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.element)
};

/* harmony default export */ var seller_info = (seller_info_SellerInfo);
// EXTERNAL MODULE: ./src/shared/seller_level/style.scss
var seller_level_style = __webpack_require__("W2uZ");
var seller_level_style_default = /*#__PURE__*/__webpack_require__.n(seller_level_style);

// CONCATENATED MODULE: ./src/shared/seller_level/index.js




var seller_level_SellerLevel = function SellerLevel(_ref) {
    var level = _ref.level,
        isPro = _ref.isPro,
        isLimitedEdition = _ref.isLimitedEdition,
        isNewSeller = _ref.isNewSeller;

    var sellerLevelProps = {
        className: 'gig-seller-tooltip'
    };

    var levelText = '';

    if (isLimitedEdition) {
        level = 'pro_spotlight_seller';
    }

    switch (level) {
        case 'level_one_seller':
        case 'level_two_seller':
        case 'pro_spotlight_seller':
            levelText = i18n.t('seller_levels.' + level);
            break;
        case 'top_rated_seller':
            levelText = i18n.t('seller_levels.' + level);
            levelText = external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'em',
                null,
                levelText
            );
            break;
        default:
            if (isPro) {
                levelText = i18n.t('seller_levels.new_pro');
            } else if (isNewSeller) {
                levelText = i18n.t('seller_levels.new_seller');
            }

            break;
    }

    if (level) {
        sellerLevelProps.className += ' badge-hint js-badge-hint';
        sellerLevelProps['data-hint'] = i18n.t('seller_levels.' + level + '_tooltip');
    }

    return levelText ? external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'div',
        sellerLevelProps,
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'span',
            { className: 'seller-level' },
            levelText
        )
    ) : null;
};

seller_level_SellerLevel.propTypes = {
    level: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    isPro: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool,
    isLimitedEdition: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool,
    isNewSeller: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool
};

/* harmony default export */ var seller_level = (seller_level_SellerLevel);
// CONCATENATED MODULE: ./src/shared/seller_response_time/index.js



var seller_response_time_SellerResponseTime = function SellerResponseTime(_ref) {
    var responseTime = _ref.responseTime,
        comma = _ref.comma;
    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'span',
        { className: 'seller-response-time' },
        comma ? ', ' : '',
        responseTime,
        ' Avg Response Time'
    );
};

seller_response_time_SellerResponseTime.propTypes = {
    comma: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool,
    responseTime: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string
};

/* harmony default export */ var seller_response_time = (seller_response_time_SellerResponseTime);
// EXTERNAL MODULE: ./node_modules/dateformat/lib/dateformat.js
var dateformat = __webpack_require__("CqLJ");
var dateformat_default = /*#__PURE__*/__webpack_require__.n(dateformat);

// CONCATENATED MODULE: ./src/utils/getItByDate/index.js



/**
 * Calculate the earliest date the gig can be delivered
 * @param  {Integer} {fastestDeliveryTime} The gig's fastest delivery time (number of days)
 * @return {String} The earliest date the gig can be delivered
 */

function getItByDate(fastestDeliveryTime) {
    var today = new Date(),
        deliveryDate = new Date(),
        isTomorrow = fastestDeliveryTime === 1;

    deliveryDate.setDate(today.getDate() + fastestDeliveryTime);

    var day = deliveryDate.getDate(),
        month = deliveryDate.getMonth(),
        dayOfWeekIndex = deliveryDate.getDay(),
        dayOfWeek = dateformat_default.a.i18n.dayNames[dayOfWeekIndex + 7],
        prefix = isTomorrow ? i18n.t('delivery_time.tomorrow') : dayOfWeek,
        monthName = dateformat_default.a.i18n.monthNames[month];

    return prefix + ', ' + monthName + ' ' + day;
}
// EXTERNAL MODULE: ./src/shared/delivery_time/style.scss
var delivery_time_style = __webpack_require__("dZ1e");
var delivery_time_style_default = /*#__PURE__*/__webpack_require__.n(delivery_time_style);

// CONCATENATED MODULE: ./src/shared/delivery_time/index.js







var MAX_DELIVERY_TIME = 7;

var delivery_time_DeliveryTime = function DeliveryTime(_ref) {
    var gigUrl = _ref.gigUrl,
        deliveryTime = _ref.deliveryTime,
        cardType = _ref.cardType,
        cardSize = _ref.cardSize;

    var shouldDisplayDeliveryTime = deliveryTime > 0 && deliveryTime < MAX_DELIVERY_TIME;

    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'div',
        { className: 'get-it-by' },
        shouldDisplayDeliveryTime && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'a',
            { href: gigUrl,
                onClick: function onClick() {
                    return trackEvent('delivery_time', cardType, cardSize);
                } },
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'span',
                null,
                ' ',
                i18n.t('delivery_time.get_it_by'),
                ' ',
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'strong',
                    null,
                    getItByDate(deliveryTime)
                )
            )
        )
    );
};

delivery_time_DeliveryTime.propTypes = {
    gigUrl: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    deliveryTime: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.number,
    cardType: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string
};

var delivery_time_contextSelector = function contextSelector(_ref2) {
    var cardType = _ref2.cardType,
        cardSize = _ref2.cardSize;
    return { cardType: cardType, cardSize: cardSize };
};

/* harmony default export */ var delivery_time = (gig_card_context_withGigCardContext(delivery_time_contextSelector)(delivery_time_DeliveryTime));
// EXTERNAL MODULE: ./src/shared/title/style.scss
var title_style = __webpack_require__("bv8i");
var title_style_default = /*#__PURE__*/__webpack_require__.n(title_style);

// CONCATENATED MODULE: ./src/shared/title/index.js






var addSpaceToClasses = function addSpaceToClasses(classes) {
    return ' ' + classes + ' ';
},
    title_Title = function Title(_ref) {
    var gigUrl = _ref.gigUrl,
        caption = _ref.caption,
        classes = _ref.classes,
        cardType = _ref.cardType,
        cardSize = _ref.cardSize;
    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'a',
        { href: gigUrl,
            onClick: function onClick() {
                return trackEvent('title', cardType, cardSize);
            },
            className: 'gig-link-main' + (classes ? addSpaceToClasses(classes) : '') + ' js-gig-card-imp-data',
            rel: 'nofollow',
            title: caption },
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'h3',
            null,
            caption
        )
    );
};

title_Title.propTypes = {
    gigUrl: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    caption: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    cardType: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string
};

var title_contextSelector = function contextSelector(_ref2) {
    var cardType = _ref2.cardType,
        cardSize = _ref2.cardSize;
    return { cardType: cardType, cardSize: cardSize };
};

/* harmony default export */ var title = (gig_card_context_withGigCardContext(title_contextSelector)(title_Title));
// CONCATENATED MODULE: ./src/shared/username/index.js





var username_Username = function Username(_ref) {
    var name = _ref.name,
        url = _ref.url,
        prefix = _ref.prefix,
        cardType = _ref.cardType,
        cardSize = _ref.cardSize;
    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'a',
        { href: url, rel: 'nofollow', className: 'seller-name', onClick: function onClick() {
                return trackEvent('username', cardType, cardSize);
            } },
        prefix ? prefix + ' ' : '',
        name
    );
};

username_Username.propTypes = {
    name: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    url: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    prefix: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    cardType: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string
};

var username_contextSelector = function contextSelector(_ref2) {
    var cardType = _ref2.cardType,
        cardSize = _ref2.cardSize;
    return { cardType: cardType, cardSize: cardSize };
};

/* harmony default export */ var username = (gig_card_context_withGigCardContext(username_contextSelector)(username_Username));
// CONCATENATED MODULE: ./src/shared/index.js
























// CONCATENATED MODULE: ./src/utils/getCurrency/index.js
/**
 * [description]
 * @param  {String|Number} price
 * @return {String}        converted currency (if converter available)
 */
var formatPrice = function formatPrice(price) {
  return '$' + price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

var getCurrency = function getCurrency(price) {
  var getCurrencyString = typeof ft !== 'undefined' ? ft.utl.getCurrencyString : formatPrice; // eslint-disable-line no-undef

  return typeof price === 'number' || typeof price === 'string' ? getCurrencyString(price, true, true, true) : '';
};
// CONCATENATED MODULE: ./src/utils/adaptGigData/index.js
/**
 * Mutates the Gig data object
 * @param  {Object} gigData           Gig data object
 * @param  {Object} [options]
 * @param  {Object} [options.context] Context object
 * @return {Object} gigData           Mutated object
 */
var adaptGigData = function adaptGigData(gigData) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        context = _ref.context;

    if (!context) {
        return gigData;
    }

    return ['gig_url', 'seller_url'].reduce(function (gigData, item) {
        gigData[item] = addRefCtxId(gigData[item], context);

        return gigData;
    }, gigData);
};

/**
 * Add ref_ctx_id to URL where applicable
 * @param {String} url
 * @param {Object} [context={}]
 * @param {String} [context.refCtxId]
 * @param {String} [context.pageCtxId]
 */
var addRefCtxId = function addRefCtxId(url) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var ref_ctx_id = context.refCtxId || context.pageCtxId;

    if (!ref_ctx_id) {
        return url;
    }

    return new Fiverr.URI(url).addParams({ ref_ctx_id: ref_ctx_id }).href;
};
// CONCATENATED MODULE: ./src/utils/getGigAssets/index.js
function getGigAssets(gig) {
    var gigAssets = gig.assets && gig.assets.length > 0 ? gig.assets : [],
        mainAsset = {
        img_medium: gig.img_medium,
        image_data: gig.image_data,
        asset_type: 'image'
    };

    if (gig.video_url) {
        mainAsset.asset_type = 'video';
        mainAsset.video_stream_url = gig.video_stream_url;
        mainAsset.video_thumb = gig.video_thumb;
        mainAsset.video_thumb_lrg = gig.video_thumb_lrg;
        mainAsset.video_url = gig.video_url;
        mainAsset.seller_id = gig.seller_id;
    }

    gigAssets.shift();
    gigAssets.unshift(mainAsset);
    return gigAssets;
}
// CONCATENATED MODULE: ./src/utils/gigTypes/index.js
var LIQUID_ENGINE = 'liquid_engine';
var PPC_BADGE_TEST = 'ad_test';

/**
 * Whether or not a gig is considered a "rising talent".
 * @param  {String}  [gigType=''] The gig's type.
 * @return {Boolean}
 */
var isRisingTalent = function isRisingTalent() {
  var gigType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return gigType === LIQUID_ENGINE;
};

/**
 * Whether or not a gig is in the ppc ad badge test.
 * @param  {String}  [gigType=''] The gig's type.
 * @return {Boolean}
 */
var inPpcAdBadgeTest = function inPpcAdBadgeTest() {
  var gigType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return gigType === PPC_BADGE_TEST;
};
// CONCATENATED MODULE: ./src/utils/gigCardExperiments/index.js
/**
 * Whether or not a user is in a certain experiments variation.
 * @param  {Object} [experiments={}] The hash of the users current experiments
 * @param  {String} [experimentKey=''] Key for the experiment to check
 * @param  {Number} [variation=2] value to check the against
 * @return {Boolean}
*/

var gigCardExperiments = function gigCardExperiments() {
  var experiments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function () {
    var experimentKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var variation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    return experiments[experimentKey] === variation;
  };
};
// CONCATENATED MODULE: ./src/utils/index.js






// CONCATENATED MODULE: ./src/mp_gig_card/GigCard.js
var GigCard__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function GigCard__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function GigCard__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function GigCard__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









// TODO: clean up isFooterReversed and make this a functional component

var GigCard_GigCard = function (_PureComponent) {
    GigCard__inherits(GigCard, _PureComponent);

    function GigCard(props) {
        GigCard__classCallCheck(this, GigCard);

        var _this = GigCard__possibleConstructorReturn(this, (GigCard.__proto__ || Object.getPrototypeOf(GigCard)).call(this, props));

        _this.state = {
            unmounting: false
        };

        i18n.add(translations_en_default.a);
        return _this;
    }

    GigCard__createClass(GigCard, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            // Any data that requires the use of the window object
            // should be initialized here due to SSR restrictions.

            this.setState({ // eslint-disable-line
                gigPrice: getCurrency(this.props.gig.price_i, true),
                averagePrice: this.props.gig.average_price && getCurrency(this.props.gig.average_price, true),
                medianPrice: this.props.gig.median_price && getCurrency(this.props.gig.median_price, true)
            });
        }
    }, {
        key: 'isFooterReversed',
        value: function isFooterReversed(abTests) {
            var avgMedVariations = [2, 3];

            return abTests && avgMedVariations.indexOf(abTests.AVG_MEDIAN_PRICE_2) > -1;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                user = _props.user,
                updateCollections = _props.updateCollections,
                gig = _props.gig,
                context = _props.context;

            var inExperiment = gigCardExperiments(context.abTests),
                userId = user && user.userId || null,
                risingTalent = isRisingTalent(gig.type),
                shouldRenderRating = (gig.rating > 0 || gig.is_pro) && !risingTalent,
                isLimitedEdition = gig.is_limited_edition,
                limitDisplayedRatings = inExperiment('RATINGS_THRESHOLD_ONE_HUNDRED'),
                shouldRenderDeliveryTime = inExperiment('GET_IT_BY'),
                showHighCompletionRate = inExperiment('HIGH_COMPLETION_RATE_GIG_BADGE') && gig.high_completion_rate;

            adaptGigData(gig, { context: context });

            return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                card_shell,
                { cardType: 'card', cacheKey: 'gig_card-' + gig.cacheKey, key: gig.gig_id, type: 'mp-gig-card', gigId: gig.gig_id, cachedSlug: gig.cached_slug, position: gig.pos },
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'a',
                    { key: 'title-link-' + gig.gig_id, href: gig.gig_url, className: 'js-gig-card-imp-data' },
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(shared_media, { key: 'media-' + gig.gig_id, assets: getGigAssets(gig), gigId: gig.gig_id, userId: userId })
                ),
                inPpcAdBadgeTest(gig.type) && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    dist["Status"],
                    { classes: 'ppc-badge' },
                    i18n.t('badges.ppc.caption')
                ),
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'div',
                    { className: 'gig-card-caption' },
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                        seller_info,
                        null,
                        gig.is_seller_online && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('span', { className: 'is-online' }),
                        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(dist["Avatar"], { src: gig.seller_img }),
                        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(username, { name: gig.seller_name, url: gig.seller_url }),
                        !risingTalent && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(seller_level, { level: gig.seller_level, isPro: gig.is_pro, isLimitedEdition: isLimitedEdition, isNewSeller: gig.is_new_seller })
                    ),
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(title, { gigUrl: gig.gig_url, caption: gig.iwill_title }),
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                        'div',
                        { className: 'rating-badges-container' },
                        shouldRenderRating && !isLimitedEdition && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(rating, { score: gig.rating, gigId: gig.gig_id, votes: gig.rating_count, starSize: 15, starCount: 1, isPro: gig.is_pro, limitDisplayedRatings: limitDisplayedRatings }),
                        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(gig_badges, { featured: gig.is_featured,
                            limitedEdition: gig.is_limited_edition,
                            limitedEditionDeadline: gig.limited_edition_expires_at,
                            qualityChoice: gig.quality_choice,
                            reliable: showHighCompletionRate,
                            availableNow: gig.is_available_now,
                            risingTalent: risingTalent,
                            sellerName: gig.seller_name,
                            pro: gig.is_pro,
                            gigId: gig.gig_id })
                    )
                ),
                shouldRenderDeliveryTime && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(delivery_time, { deliveryTime: gig.fastest_delivery_time, gigUrl: gig.gig_url }),
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'footer',
                    { className: 'gig-card-footer' + (this.isFooterReversed(context.abTests) ? ' reversed' : '') },
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(collect_gig, { gigId: gig.gig_id, sellerId: gig.seller_id, updateCollections: updateCollections, user: user, showCollMenu: true, icon: 'ficon ficon-bars' }),
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(shared_price, { gigUrl: gig.gig_url,
                        price: this.state.gigPrice,
                        showStartingAt: gig.show_starting_at,
                        isLimitedEdition: isLimitedEdition,
                        averagePrice: this.state.averagePrice,
                        medianPrice: this.state.medianPrice })
                )
            );
        }
    }]);

    return GigCard;
}(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__["PureComponent"]);

GigCard_GigCard.propTypes = {
    user: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.object,
    gig: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.object,
    context: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.shape({
        pageCtxId: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
        refCtxId: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
        abTests: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.object
    })
};

GigCard_GigCard.defaultProps = {
    context: {}
};

/* harmony default export */ var mp_gig_card_GigCard = (GigCard_GigCard);
// EXTERNAL MODULE: ./src/shared/gig_cards_repeater/style.scss
var gig_cards_repeater_style = __webpack_require__("yhus");
var gig_cards_repeater_style_default = /*#__PURE__*/__webpack_require__.n(gig_cards_repeater_style);

// CONCATENATED MODULE: ./src/shared/gig_cards_repeater/index.js





var gig_cards_repeater_GigCardsRepeater = function GigCardsRepeater(_ref) {
    var context = _ref.context,
        children = _ref.children,
        responsiveGrid = _ref.responsiveGrid;

    var classes = ['react-gig-cards-slider', 'slider-hider'];

    responsiveGrid ? classes.push('row') : classes.push('cf');

    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        gig_card_context_GigCardContextProvider,
        { value: context },
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'div',
            { className: classes.join(' ') },
            children.map(function (child, i) {
                return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'div',
                    { key: 'gig_item_' + i, className: 'gig-item ' + context.cardSize },
                    child
                );
            })
        )
    );
};

gig_cards_repeater_GigCardsRepeater.propTypes = {
    context: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.object,
    children: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.array,
    responsiveGrid: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool
};

/* harmony default export */ var gig_cards_repeater = (gig_cards_repeater_GigCardsRepeater);
// EXTERNAL MODULE: ./src/mp_gig_card/style.scss
var mp_gig_card_style = __webpack_require__("C4SN");
var mp_gig_card_style_default = /*#__PURE__*/__webpack_require__.n(mp_gig_card_style);

// CONCATENATED MODULE: ./src/mp_gig_card/index.js
var mp_gig_card__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var mp_gig_card__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function mp_gig_card__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function mp_gig_card__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function mp_gig_card__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var mp_gig_card_GigCards = function (_PureComponent) {
    mp_gig_card__inherits(GigCards, _PureComponent);

    function GigCards(props) {
        mp_gig_card__classCallCheck(this, GigCards);

        var _this = mp_gig_card__possibleConstructorReturn(this, (GigCards.__proto__ || Object.getPrototypeOf(GigCards)).call(this, props));

        _this.state = {
            unmounting: false,
            collections: false
        };

        i18n.add(translations_en_default.a);

        _this.getCollections = _this.getCollections.bind(_this);
        _this.updateCollections = _this.updateCollections.bind(_this);
        return _this;
    }

    mp_gig_card__createClass(GigCards, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            if (this.props.user) {
                this.getCollections().then(function (json) {
                    _this2.setState({ collections: json });
                });
            }
        }
    }, {
        key: 'updateCollections',
        value: function updateCollections(collections) {
            this.setState({ collections: collections });
        }
    }, {
        key: 'getCollections',
        value: function getCollections() {
            var _this3 = this;

            var _props = this.props,
                gigs = _props.gigs,
                user = _props.user,
                hearts = gigs.map(function (gig) {
                return gig.gig_id;
            });


            if (!user) {
                return;
            }

            return collection.getCollections(hearts).then(function (json) {
                _this3.setState({ collections: json });return json;
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var _props2 = this.props,
                gigs = _props2.gigs,
                user = _props2.user,
                cardSize = _props2.cardSize,
                responsiveGrid = _props2.responsiveGrid,
                _props2$context = _props2.context,
                context = _props2$context === undefined ? {} : _props2$context,
                collections = this.state.collections;


            return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                gig_cards_repeater,
                { context: mp_gig_card__extends({ cardType: 'card', cardSize: cardSize, collections: collections, user: user }, context), responsiveGrid: responsiveGrid },
                gigs.map(function (gig) {
                    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(mp_gig_card_GigCard, { key: gig.gig_id, gig: gig, updateCollections: _this4.updateCollections, user: user, context: context });
                })
            );
        }
    }]);

    return GigCards;
}(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__["PureComponent"]);

mp_gig_card_GigCards.propTypes = {
    responsiveGrid: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool,
    user: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.object,
    gigs: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.array,
    cardSize: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    context: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.shape({
        pageCtxId: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
        refCtxId: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string
    })
};

mp_gig_card_GigCards.defaultProps = {
    cardSize: 'medium',
    responsiveGrid: false
};

/* harmony default export */ var mp_gig_card = (mp_gig_card_GigCards);
// EXTERNAL MODULE: ./src/list_view_card/style.scss
var list_view_card_style = __webpack_require__("odPn");
var list_view_card_style_default = /*#__PURE__*/__webpack_require__.n(list_view_card_style);

// CONCATENATED MODULE: ./src/list_view_card/ListView.js








var ListView_ListViewItem = function ListViewItem(_ref) {
    var gig = _ref.gig,
        user = _ref.user,
        updateCollections = _ref.updateCollections,
        _ref$context = _ref.context,
        context = _ref$context === undefined ? {} : _ref$context;

    var inExperiment = gigCardExperiments(context.abTests),
        userId = user && user.userId || null,
        risingTalent = isRisingTalent(gig.type),
        limitDisplayedRatings = inExperiment('RATINGS_THRESHOLD_ONE_HUNDRED'),
        showHighCompletionRate = inExperiment('HIGH_COMPLETION_RATE_GIG_BADGE') && gig.high_completion_rate,
        shouldRenderRating = (gig.rating > 0 || gig.is_pro) && !risingTalent;

    adaptGigData(gig, { context: context });

    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        card_shell,
        { key: gig.gig_id, type: 'list-view-card', gigId: gig.gig_id },
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'div',
            { className: 'flex-row' },
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'div',
                { className: 'col-media' },
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'a',
                    { href: gig.gig_url, className: 'js-gig-card-imp-data' },
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(shared_media, { assets: getGigAssets(gig), gigId: gig.gig_id, userId: userId })
                )
            ),
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'div',
                { className: 'col-gig-info' },
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(title, { gigUrl: gig.gig_url, caption: gig.iwill_title }),
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'div',
                    { className: 'desktop' },
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                        seller_info,
                        null,
                        gig.is_seller_online && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('span', { className: 'is-online' }),
                        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(dist["Avatar"], { src: gig.seller_img }),
                        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(username, { name: gig.seller_name, url: gig.seller_url, prefix: i18n.t('general.by'), context: context }),
                        !risingTalent && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(seller_level, { level: gig.seller_level, isPro: gig.is_pro, isNewSeller: gig.is_new_seller }),
                        gig.seller_country_name && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(seller_country, { country: gig.seller_country_name, comma: gig.seller_level || gig.is_pro }),
                        gig.seller_avg_response && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(seller_response_time, { responseTime: gig.seller_avg_response, comma: true })
                    ),
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(shared_price, { gigUrl: gig.gig_url,
                        price: getCurrency(gig.price_i, true),
                        showStartingAt: gig.show_starting_at,
                        averagePrice: getCurrency(gig.average_price),
                        medianPrice: getCurrency(gig.median_price) })
                ),
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'div',
                    { className: 'rating-badges-container' },
                    shouldRenderRating && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(rating, { score: gig.rating, gigId: gig.gig_id, votes: gig.rating_count, starSize: 16, starCount: 1, isPro: gig.is_pro, limitDisplayedRatings: limitDisplayedRatings }),
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(gig_badges, { featured: gig.is_featured,
                        limitedEdition: gig.is_limited_edition,
                        limitedEditionDeadline: gig.limited_edition_expires_at,
                        qualityChoice: gig.quality_choice,
                        reliable: showHighCompletionRate,
                        availableNow: gig.is_available_now,
                        risingTalent: risingTalent,
                        sellerName: gig.seller_name,
                        pro: gig.is_pro,
                        gigId: gig.gig_id })
                ),
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(list_view_info, { platforms: gig.metadata && gig.metadata.platform ? gig.metadata.platform : null,
                    skills: gig.skills,
                    avgDeliveryTime: gig.avg_delivery_time }),
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(collect_gig, { gigId: gig.gig_id, sellerId: gig.seller_id, updateCollections: updateCollections, user: user, showCollMenu: true, icon: 'fa fa-ellipsis-v' })
            )
        ),
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'div',
            { className: 'flex-row space-between mobile' },
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                seller_info,
                null,
                gig.is_seller_online && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('span', { className: 'is-online' }),
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(dist["Avatar"], { src: gig.seller_img }),
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(username, { name: gig.seller_name, url: gig.seller_url, prefix: i18n.t('general.by'), context: context }),
                !risingTalent && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(seller_level, { level: gig.seller_level, isPro: gig.is_pro, isLimitedEdition: gig.is_limited_edition, isNewSeller: gig.is_new_seller })
            ),
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(shared_price, { gigUrl: gig.gig_url,
                price: getCurrency(gig.price_i, true),
                showStartingAt: gig.show_starting_at,
                isLimitedEdition: gig.is_limited_edition,
                averagePrice: getCurrency(gig.average_price),
                medianPrice: getCurrency(gig.median_price) })
        )
    );
};

ListView_ListViewItem.propTypes = {
    gig: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.obj,
    user: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.obj,
    updateCollections: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.func,
    context: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.obj
};

/* harmony default export */ var list_view_card_ListView = (ListView_ListViewItem);
// CONCATENATED MODULE: ./src/utils/mediaListener.js
function addMediaListener(mediaQuery, callBack) {
    var mq = window && window.matchMedia(mediaQuery),
        handler = function handler() {
        return callBack(mq);
    };

    mq.addListener(handler);

    callBack(mq);

    return function () {
        return mq.removeListener(handler);
    };
}
// CONCATENATED MODULE: ./src/list_view_card/index.js
var list_view_card__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var list_view_card__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function list_view_card__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function list_view_card__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function list_view_card__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var src_list_view_card_ListView = function (_PureComponent) {
    list_view_card__inherits(ListView, _PureComponent);

    function ListView(props) {
        list_view_card__classCallCheck(this, ListView);

        var _this = list_view_card__possibleConstructorReturn(this, (ListView.__proto__ || Object.getPrototypeOf(ListView)).call(this, props));

        _this.state = {
            unmounting: false,
            collections: false,
            isMobile: _this.props.isMobile
        };

        _this.updateCollections = _this.updateCollections.bind(_this);

        i18n.add(translations_en_default.a);
        return _this;
    }

    list_view_card__createClass(ListView, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            if (this.props.user) {
                this.getCollections().then(function (json) {
                    _this2.setState({ collections: json });
                });
            }

            this.removeMediaListener = addMediaListener('(min-width: 600px)', function (mq) {
                return _this2.setState({ isMobile: !mq.matches });
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.removeMediaListener && this.removeMediaListener();
        }
    }, {
        key: 'updateCollections',
        value: function updateCollections(collections) {
            this.setState({ collections: collections });
        }
    }, {
        key: 'getCollections',
        value: function getCollections() {
            var _this3 = this;

            var _props = this.props,
                gigs = _props.gigs,
                user = _props.user,
                hearts = gigs.map(function (gig) {
                return gig.gig_id;
            });


            if (!user) {
                return;
            }

            return collection.getCollections(hearts).then(function (json) {
                _this3.setState({ collections: json });return json;
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var _props2 = this.props,
                gigs = _props2.gigs,
                user = _props2.user,
                responsiveGrid = _props2.responsiveGrid,
                _props2$context = _props2.context,
                context = _props2$context === undefined ? {} : _props2$context,
                _state = this.state,
                collections = _state.collections,
                isMobile = _state.isMobile,
                cardTypeVal = 'list';


            return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                gig_card_context_GigCardContextProvider,
                { value: list_view_card__extends({ cardType: cardTypeVal, collections: collections, user: user }, context) },
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'div',
                    { className: 'react-gig-cards-slider list-view-slider slider-hider cf' },
                    gigs.map(function (gig, i) {
                        return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(list_view_card_ListView, { key: 'list-view-' + i,
                            isMobile: isMobile,
                            gig: gig,
                            user: user,
                            responsiveGrid: responsiveGrid,
                            context: context,
                            updateCollections: _this4.updateCollections });
                    })
                )
            );
        }
    }]);

    return ListView;
}(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__["PureComponent"]);

src_list_view_card_ListView.propTypes = {
    user: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.object,
    gigs: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.array,
    responsiveGrid: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool,
    isMobile: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool,
    context: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.shape({
        pageCtxId: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
        refCtxId: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string
    })
};

src_list_view_card_ListView.defaultProps = {
    responsiveGrid: false
};

/* harmony default export */ var list_view_card = (src_list_view_card_ListView);
// CONCATENATED MODULE: ./src/port.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "GigCards", function() { return mp_gig_card; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "GigCard", function() { return mp_gig_card_GigCard; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ListView", function() { return list_view_card; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ListViewItem", function() { return list_view_card_ListView; });





if (typeof document !== 'undefined') {
    window.ListViewCard = list_view_card;
    window.BuyerGigCard = mp_gig_card;
}



/***/ }),

/***/ "fRv3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ijbM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lCso":
/***/ (function(module, exports, __webpack_require__) {

var extend = __webpack_require__("ouFg");
var ArrayWeakMap = __webpack_require__("bQni");

var defaultRootComponent;
var defaultRootKey = {};
var componentPromises = new ArrayWeakMap();

var updateRootComponent = function(rootComponent) {
  var componentKey = rootComponent || defaultRootKey;

  if (!componentPromises.has(componentKey)) {
    var componentToUpdate = rootComponent || defaultRootComponent;

    if (componentToUpdate) {
      this.setTimeout(function() {
        if (componentToUpdate.isMounted()) {
          componentToUpdate.forceUpdate();
        }
      }, 0);
    }
  }
};

module.exports = {

  extend: function() {

    var Store = function() {
      this.updateRootComponent = function(promise) {
        if (promise) {
          var componentKey = this.rootComponent || defaultRootKey;
          componentPromises.addArrayItem(componentKey, promise);
          var _this = this;

          var onResolveOrReject = function() {
            componentPromises.removeArrayItem(componentKey, promise);
            updateRootComponent(_this.rootComponent);
          };

          promise.then(onResolveOrReject, onResolveOrReject);
        }
        else {
          updateRootComponent(this.rootComponent);
        }
      };
    };

    // prepend Store to arguments
    Array.prototype.unshift.call(arguments, Store.prototype);
    extend.apply(null, arguments);

    var store = new Store();

    return store;
  },

  init: function(options) {
    defaultRootComponent = options.rootComponent;
  }

};

/***/ }),

/***/ "lP53":
/***/ (function(module, exports) {

// Copyright (C) 2011 Google Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

/**
 * @fileoverview Install a leaky WeakMap emulation on platforms that
 * don't provide a built-in one.
 *
 * <p>Assumes that an ES5 platform where, if {@code WeakMap} is
 * already present, then it conforms to the anticipated ES6
 * specification. To run this file on an ES5 or almost ES5
 * implementation where the {@code WeakMap} specification does not
 * quite conform, run <code>repairES5.js</code> first.
 *
 * <p>Even though WeakMapModule is not global, the linter thinks it
 * is, which is why it is in the overrides list below.
 *
 * <p>NOTE: Before using this WeakMap emulation in a non-SES
 * environment, see the note below about hiddenRecord.
 *
 * @author Mark S. Miller
 * @requires crypto, ArrayBuffer, Uint8Array, navigator, console
 * @overrides WeakMap, ses, Proxy
 * @overrides WeakMapModule
 */

/**
 * This {@code WeakMap} emulation is observably equivalent to the
 * ES-Harmony WeakMap, but with leakier garbage collection properties.
 *
 * <p>As with true WeakMaps, in this emulation, a key does not
 * retain maps indexed by that key and (crucially) a map does not
 * retain the keys it indexes. A map by itself also does not retain
 * the values associated with that map.
 *
 * <p>However, the values associated with a key in some map are
 * retained so long as that key is retained and those associations are
 * not overridden. For example, when used to support membranes, all
 * values exported from a given membrane will live for the lifetime
 * they would have had in the absence of an interposed membrane. Even
 * when the membrane is revoked, all objects that would have been
 * reachable in the absence of revocation will still be reachable, as
 * far as the GC can tell, even though they will no longer be relevant
 * to ongoing computation.
 *
 * <p>The API implemented here is approximately the API as implemented
 * in FF6.0a1 and agreed to by MarkM, Andreas Gal, and Dave Herman,
 * rather than the offially approved proposal page. TODO(erights):
 * upgrade the ecmascript WeakMap proposal page to explain this API
 * change and present to EcmaScript committee for their approval.
 *
 * <p>The first difference between the emulation here and that in
 * FF6.0a1 is the presence of non enumerable {@code get___, has___,
 * set___, and delete___} methods on WeakMap instances to represent
 * what would be the hidden internal properties of a primitive
 * implementation. Whereas the FF6.0a1 WeakMap.prototype methods
 * require their {@code this} to be a genuine WeakMap instance (i.e.,
 * an object of {@code [[Class]]} "WeakMap}), since there is nothing
 * unforgeable about the pseudo-internal method names used here,
 * nothing prevents these emulated prototype methods from being
 * applied to non-WeakMaps with pseudo-internal methods of the same
 * names.
 *
 * <p>Another difference is that our emulated {@code
 * WeakMap.prototype} is not itself a WeakMap. A problem with the
 * current FF6.0a1 API is that WeakMap.prototype is itself a WeakMap
 * providing ambient mutability and an ambient communications
 * channel. Thus, if a WeakMap is already present and has this
 * problem, repairES5.js wraps it in a safe wrappper in order to
 * prevent access to this channel. (See
 * PATCH_MUTABLE_FROZEN_WEAKMAP_PROTO in repairES5.js).
 */

/**
 * If this is a full <a href=
 * "http://code.google.com/p/es-lab/wiki/SecureableES5"
 * >secureable ES5</a> platform and the ES-Harmony {@code WeakMap} is
 * absent, install an approximate emulation.
 *
 * <p>If WeakMap is present but cannot store some objects, use our approximate
 * emulation as a wrapper.
 *
 * <p>If this is almost a secureable ES5 platform, then WeakMap.js
 * should be run after repairES5.js.
 *
 * <p>See {@code WeakMap} for documentation of the garbage collection
 * properties of this WeakMap emulation.
 */
(function WeakMapModule() {
  "use strict";

  if (typeof ses !== 'undefined' && ses.ok && !ses.ok()) {
    // already too broken, so give up
    return;
  }

  /**
   * In some cases (current Firefox), we must make a choice betweeen a
   * WeakMap which is capable of using all varieties of host objects as
   * keys and one which is capable of safely using proxies as keys. See
   * comments below about HostWeakMap and DoubleWeakMap for details.
   *
   * This function (which is a global, not exposed to guests) marks a
   * WeakMap as permitted to do what is necessary to index all host
   * objects, at the cost of making it unsafe for proxies.
   *
   * Do not apply this function to anything which is not a genuine
   * fresh WeakMap.
   */
  function weakMapPermitHostObjects(map) {
    // identity of function used as a secret -- good enough and cheap
    if (map.permitHostObjects___) {
      map.permitHostObjects___(weakMapPermitHostObjects);
    }
  }
  if (typeof ses !== 'undefined') {
    ses.weakMapPermitHostObjects = weakMapPermitHostObjects;
  }

  // IE 11 has no Proxy but has a broken WeakMap such that we need to patch
  // it using DoubleWeakMap; this flag tells DoubleWeakMap so.
  var doubleWeakMapCheckSilentFailure = false;

  // Check if there is already a good-enough WeakMap implementation, and if so
  // exit without replacing it.
  if (typeof WeakMap === 'function') {
    var HostWeakMap = WeakMap;
    // There is a WeakMap -- is it good enough?
    if (typeof navigator !== 'undefined' &&
        /Firefox/.test(navigator.userAgent)) {
      // We're now *assuming not*, because as of this writing (2013-05-06)
      // Firefox's WeakMaps have a miscellany of objects they won't accept, and
      // we don't want to make an exhaustive list, and testing for just one
      // will be a problem if that one is fixed alone (as they did for Event).

      // If there is a platform that we *can* reliably test on, here's how to
      // do it:
      //  var problematic = ... ;
      //  var testHostMap = new HostWeakMap();
      //  try {
      //    testHostMap.set(problematic, 1);  // Firefox 20 will throw here
      //    if (testHostMap.get(problematic) === 1) {
      //      return;
      //    }
      //  } catch (e) {}

    } else {
      // IE 11 bug: WeakMaps silently fail to store frozen objects.
      var testMap = new HostWeakMap();
      var testObject = Object.freeze({});
      testMap.set(testObject, 1);
      if (testMap.get(testObject) !== 1) {
        doubleWeakMapCheckSilentFailure = true;
        // Fall through to installing our WeakMap.
      } else {
        module.exports = WeakMap;
        return;
      }
    }
  }

  var hop = Object.prototype.hasOwnProperty;
  var gopn = Object.getOwnPropertyNames;
  var defProp = Object.defineProperty;
  var isExtensible = Object.isExtensible;

  /**
   * Security depends on HIDDEN_NAME being both <i>unguessable</i> and
   * <i>undiscoverable</i> by untrusted code.
   *
   * <p>Given the known weaknesses of Math.random() on existing
   * browsers, it does not generate unguessability we can be confident
   * of.
   *
   * <p>It is the monkey patching logic in this file that is intended
   * to ensure undiscoverability. The basic idea is that there are
   * three fundamental means of discovering properties of an object:
   * The for/in loop, Object.keys(), and Object.getOwnPropertyNames(),
   * as well as some proposed ES6 extensions that appear on our
   * whitelist. The first two only discover enumerable properties, and
   * we only use HIDDEN_NAME to name a non-enumerable property, so the
   * only remaining threat should be getOwnPropertyNames and some
   * proposed ES6 extensions that appear on our whitelist. We monkey
   * patch them to remove HIDDEN_NAME from the list of properties they
   * returns.
   *
   * <p>TODO(erights): On a platform with built-in Proxies, proxies
   * could be used to trap and thereby discover the HIDDEN_NAME, so we
   * need to monkey patch Proxy.create, Proxy.createFunction, etc, in
   * order to wrap the provided handler with the real handler which
   * filters out all traps using HIDDEN_NAME.
   *
   * <p>TODO(erights): Revisit Mike Stay's suggestion that we use an
   * encapsulated function at a not-necessarily-secret name, which
   * uses the Stiegler shared-state rights amplification pattern to
   * reveal the associated value only to the WeakMap in which this key
   * is associated with that value. Since only the key retains the
   * function, the function can also remember the key without causing
   * leakage of the key, so this doesn't violate our general gc
   * goals. In addition, because the name need not be a guarded
   * secret, we could efficiently handle cross-frame frozen keys.
   */
  var HIDDEN_NAME_PREFIX = 'weakmap:';
  var HIDDEN_NAME = HIDDEN_NAME_PREFIX + 'ident:' + Math.random() + '___';

  if (typeof crypto !== 'undefined' &&
      typeof crypto.getRandomValues === 'function' &&
      typeof ArrayBuffer === 'function' &&
      typeof Uint8Array === 'function') {
    var ab = new ArrayBuffer(25);
    var u8s = new Uint8Array(ab);
    crypto.getRandomValues(u8s);
    HIDDEN_NAME = HIDDEN_NAME_PREFIX + 'rand:' +
      Array.prototype.map.call(u8s, function(u8) {
        return (u8 % 36).toString(36);
      }).join('') + '___';
  }

  function isNotHiddenName(name) {
    return !(
        name.substr(0, HIDDEN_NAME_PREFIX.length) == HIDDEN_NAME_PREFIX &&
        name.substr(name.length - 3) === '___');
  }

  /**
   * Monkey patch getOwnPropertyNames to avoid revealing the
   * HIDDEN_NAME.
   *
   * <p>The ES5.1 spec requires each name to appear only once, but as
   * of this writing, this requirement is controversial for ES6, so we
   * made this code robust against this case. If the resulting extra
   * search turns out to be expensive, we can probably relax this once
   * ES6 is adequately supported on all major browsers, iff no browser
   * versions we support at that time have relaxed this constraint
   * without providing built-in ES6 WeakMaps.
   */
  defProp(Object, 'getOwnPropertyNames', {
    value: function fakeGetOwnPropertyNames(obj) {
      return gopn(obj).filter(isNotHiddenName);
    }
  });

  /**
   * getPropertyNames is not in ES5 but it is proposed for ES6 and
   * does appear in our whitelist, so we need to clean it too.
   */
  if ('getPropertyNames' in Object) {
    var originalGetPropertyNames = Object.getPropertyNames;
    defProp(Object, 'getPropertyNames', {
      value: function fakeGetPropertyNames(obj) {
        return originalGetPropertyNames(obj).filter(isNotHiddenName);
      }
    });
  }

  /**
   * <p>To treat objects as identity-keys with reasonable efficiency
   * on ES5 by itself (i.e., without any object-keyed collections), we
   * need to add a hidden property to such key objects when we
   * can. This raises several issues:
   * <ul>
   * <li>Arranging to add this property to objects before we lose the
   *     chance, and
   * <li>Hiding the existence of this new property from most
   *     JavaScript code.
   * <li>Preventing <i>certification theft</i>, where one object is
   *     created falsely claiming to be the key of an association
   *     actually keyed by another object.
   * <li>Preventing <i>value theft</i>, where untrusted code with
   *     access to a key object but not a weak map nevertheless
   *     obtains access to the value associated with that key in that
   *     weak map.
   * </ul>
   * We do so by
   * <ul>
   * <li>Making the name of the hidden property unguessable, so "[]"
   *     indexing, which we cannot intercept, cannot be used to access
   *     a property without knowing the name.
   * <li>Making the hidden property non-enumerable, so we need not
   *     worry about for-in loops or {@code Object.keys},
   * <li>monkey patching those reflective methods that would
   *     prevent extensions, to add this hidden property first,
   * <li>monkey patching those methods that would reveal this
   *     hidden property.
   * </ul>
   * Unfortunately, because of same-origin iframes, we cannot reliably
   * add this hidden property before an object becomes
   * non-extensible. Instead, if we encounter a non-extensible object
   * without a hidden record that we can detect (whether or not it has
   * a hidden record stored under a name secret to us), then we just
   * use the key object itself to represent its identity in a brute
   * force leaky map stored in the weak map, losing all the advantages
   * of weakness for these.
   */
  function getHiddenRecord(key) {
    if (key !== Object(key)) {
      throw new TypeError('Not an object: ' + key);
    }
    var hiddenRecord = key[HIDDEN_NAME];
    if (hiddenRecord && hiddenRecord.key === key) { return hiddenRecord; }
    if (!isExtensible(key)) {
      // Weak map must brute force, as explained in doc-comment above.
      return void 0;
    }

    // The hiddenRecord and the key point directly at each other, via
    // the "key" and HIDDEN_NAME properties respectively. The key
    // field is for quickly verifying that this hidden record is an
    // own property, not a hidden record from up the prototype chain.
    //
    // NOTE: Because this WeakMap emulation is meant only for systems like
    // SES where Object.prototype is frozen without any numeric
    // properties, it is ok to use an object literal for the hiddenRecord.
    // This has two advantages:
    // * It is much faster in a performance critical place
    // * It avoids relying on Object.create(null), which had been
    //   problematic on Chrome 28.0.1480.0. See
    //   https://code.google.com/p/google-caja/issues/detail?id=1687
    hiddenRecord = { key: key };

    // When using this WeakMap emulation on platforms where
    // Object.prototype might not be frozen and Object.create(null) is
    // reliable, use the following two commented out lines instead.
    // hiddenRecord = Object.create(null);
    // hiddenRecord.key = key;

    // Please contact us if you need this to work on platforms where
    // Object.prototype might not be frozen and
    // Object.create(null) might not be reliable.

    try {
      defProp(key, HIDDEN_NAME, {
        value: hiddenRecord,
        writable: false,
        enumerable: false,
        configurable: false
      });
      return hiddenRecord;
    } catch (error) {
      // Under some circumstances, isExtensible seems to misreport whether
      // the HIDDEN_NAME can be defined.
      // The circumstances have not been isolated, but at least affect
      // Node.js v0.10.26 on TravisCI / Linux, but not the same version of
      // Node.js on OS X.
      return void 0;
    }
  }

  /**
   * Monkey patch operations that would make their argument
   * non-extensible.
   *
   * <p>The monkey patched versions throw a TypeError if their
   * argument is not an object, so it should only be done to functions
   * that should throw a TypeError anyway if their argument is not an
   * object.
   */
  (function(){
    var oldFreeze = Object.freeze;
    defProp(Object, 'freeze', {
      value: function identifyingFreeze(obj) {
        getHiddenRecord(obj);
        return oldFreeze(obj);
      }
    });
    var oldSeal = Object.seal;
    defProp(Object, 'seal', {
      value: function identifyingSeal(obj) {
        getHiddenRecord(obj);
        return oldSeal(obj);
      }
    });
    var oldPreventExtensions = Object.preventExtensions;
    defProp(Object, 'preventExtensions', {
      value: function identifyingPreventExtensions(obj) {
        getHiddenRecord(obj);
        return oldPreventExtensions(obj);
      }
    });
  })();

  function constFunc(func) {
    func.prototype = null;
    return Object.freeze(func);
  }

  var calledAsFunctionWarningDone = false;
  function calledAsFunctionWarning() {
    // Future ES6 WeakMap is currently (2013-09-10) expected to reject WeakMap()
    // but we used to permit it and do it ourselves, so warn only.
    if (!calledAsFunctionWarningDone && typeof console !== 'undefined') {
      calledAsFunctionWarningDone = true;
      console.warn('WeakMap should be invoked as new WeakMap(), not ' +
          'WeakMap(). This will be an error in the future.');
    }
  }

  var nextId = 0;

  var OurWeakMap = function() {
    if (!(this instanceof OurWeakMap)) {  // approximate test for new ...()
      calledAsFunctionWarning();
    }

    // We are currently (12/25/2012) never encountering any prematurely
    // non-extensible keys.
    var keys = []; // brute force for prematurely non-extensible keys.
    var values = []; // brute force for corresponding values.
    var id = nextId++;

    function get___(key, opt_default) {
      var index;
      var hiddenRecord = getHiddenRecord(key);
      if (hiddenRecord) {
        return id in hiddenRecord ? hiddenRecord[id] : opt_default;
      } else {
        index = keys.indexOf(key);
        return index >= 0 ? values[index] : opt_default;
      }
    }

    function has___(key) {
      var hiddenRecord = getHiddenRecord(key);
      if (hiddenRecord) {
        return id in hiddenRecord;
      } else {
        return keys.indexOf(key) >= 0;
      }
    }

    function set___(key, value) {
      var index;
      var hiddenRecord = getHiddenRecord(key);
      if (hiddenRecord) {
        hiddenRecord[id] = value;
      } else {
        index = keys.indexOf(key);
        if (index >= 0) {
          values[index] = value;
        } else {
          // Since some browsers preemptively terminate slow turns but
          // then continue computing with presumably corrupted heap
          // state, we here defensively get keys.length first and then
          // use it to update both the values and keys arrays, keeping
          // them in sync.
          index = keys.length;
          values[index] = value;
          // If we crash here, values will be one longer than keys.
          keys[index] = key;
        }
      }
      return this;
    }

    function delete___(key) {
      var hiddenRecord = getHiddenRecord(key);
      var index, lastIndex;
      if (hiddenRecord) {
        return id in hiddenRecord && delete hiddenRecord[id];
      } else {
        index = keys.indexOf(key);
        if (index < 0) {
          return false;
        }
        // Since some browsers preemptively terminate slow turns but
        // then continue computing with potentially corrupted heap
        // state, we here defensively get keys.length first and then use
        // it to update both the keys and the values array, keeping
        // them in sync. We update the two with an order of assignments,
        // such that any prefix of these assignments will preserve the
        // key/value correspondence, either before or after the delete.
        // Note that this needs to work correctly when index === lastIndex.
        lastIndex = keys.length - 1;
        keys[index] = void 0;
        // If we crash here, there's a void 0 in the keys array, but
        // no operation will cause a "keys.indexOf(void 0)", since
        // getHiddenRecord(void 0) will always throw an error first.
        values[index] = values[lastIndex];
        // If we crash here, values[index] cannot be found here,
        // because keys[index] is void 0.
        keys[index] = keys[lastIndex];
        // If index === lastIndex and we crash here, then keys[index]
        // is still void 0, since the aliasing killed the previous key.
        keys.length = lastIndex;
        // If we crash here, keys will be one shorter than values.
        values.length = lastIndex;
        return true;
      }
    }

    return Object.create(OurWeakMap.prototype, {
      get___:    { value: constFunc(get___) },
      has___:    { value: constFunc(has___) },
      set___:    { value: constFunc(set___) },
      delete___: { value: constFunc(delete___) }
    });
  };

  OurWeakMap.prototype = Object.create(Object.prototype, {
    get: {
      /**
       * Return the value most recently associated with key, or
       * opt_default if none.
       */
      value: function get(key, opt_default) {
        return this.get___(key, opt_default);
      },
      writable: true,
      configurable: true
    },

    has: {
      /**
       * Is there a value associated with key in this WeakMap?
       */
      value: function has(key) {
        return this.has___(key);
      },
      writable: true,
      configurable: true
    },

    set: {
      /**
       * Associate value with key in this WeakMap, overwriting any
       * previous association if present.
       */
      value: function set(key, value) {
        return this.set___(key, value);
      },
      writable: true,
      configurable: true
    },

    'delete': {
      /**
       * Remove any association for key in this WeakMap, returning
       * whether there was one.
       *
       * <p>Note that the boolean return here does not work like the
       * {@code delete} operator. The {@code delete} operator returns
       * whether the deletion succeeds at bringing about a state in
       * which the deleted property is absent. The {@code delete}
       * operator therefore returns true if the property was already
       * absent, whereas this {@code delete} method returns false if
       * the association was already absent.
       */
      value: function remove(key) {
        return this.delete___(key);
      },
      writable: true,
      configurable: true
    }
  });

  if (typeof HostWeakMap === 'function') {
    (function() {
      // If we got here, then the platform has a WeakMap but we are concerned
      // that it may refuse to store some key types. Therefore, make a map
      // implementation which makes use of both as possible.

      // In this mode we are always using double maps, so we are not proxy-safe.
      // This combination does not occur in any known browser, but we had best
      // be safe.
      if (doubleWeakMapCheckSilentFailure && typeof Proxy !== 'undefined') {
        Proxy = undefined;
      }

      function DoubleWeakMap() {
        if (!(this instanceof OurWeakMap)) {  // approximate test for new ...()
          calledAsFunctionWarning();
        }

        // Preferable, truly weak map.
        var hmap = new HostWeakMap();

        // Our hidden-property-based pseudo-weak-map. Lazily initialized in the
        // 'set' implementation; thus we can avoid performing extra lookups if
        // we know all entries actually stored are entered in 'hmap'.
        var omap = undefined;

        // Hidden-property maps are not compatible with proxies because proxies
        // can observe the hidden name and either accidentally expose it or fail
        // to allow the hidden property to be set. Therefore, we do not allow
        // arbitrary WeakMaps to switch to using hidden properties, but only
        // those which need the ability, and unprivileged code is not allowed
        // to set the flag.
        //
        // (Except in doubleWeakMapCheckSilentFailure mode in which case we
        // disable proxies.)
        var enableSwitching = false;

        function dget(key, opt_default) {
          if (omap) {
            return hmap.has(key) ? hmap.get(key)
                : omap.get___(key, opt_default);
          } else {
            return hmap.get(key, opt_default);
          }
        }

        function dhas(key) {
          return hmap.has(key) || (omap ? omap.has___(key) : false);
        }

        var dset;
        if (doubleWeakMapCheckSilentFailure) {
          dset = function(key, value) {
            hmap.set(key, value);
            if (!hmap.has(key)) {
              if (!omap) { omap = new OurWeakMap(); }
              omap.set(key, value);
            }
            return this;
          };
        } else {
          dset = function(key, value) {
            if (enableSwitching) {
              try {
                hmap.set(key, value);
              } catch (e) {
                if (!omap) { omap = new OurWeakMap(); }
                omap.set___(key, value);
              }
            } else {
              hmap.set(key, value);
            }
            return this;
          };
        }

        function ddelete(key) {
          var result = !!hmap['delete'](key);
          if (omap) { return omap.delete___(key) || result; }
          return result;
        }

        return Object.create(OurWeakMap.prototype, {
          get___:    { value: constFunc(dget) },
          has___:    { value: constFunc(dhas) },
          set___:    { value: constFunc(dset) },
          delete___: { value: constFunc(ddelete) },
          permitHostObjects___: { value: constFunc(function(token) {
            if (token === weakMapPermitHostObjects) {
              enableSwitching = true;
            } else {
              throw new Error('bogus call to permitHostObjects___');
            }
          })}
        });
      }
      DoubleWeakMap.prototype = OurWeakMap.prototype;
      module.exports = DoubleWeakMap;

      // define .constructor to hide OurWeakMap ctor
      Object.defineProperty(WeakMap.prototype, 'constructor', {
        value: WeakMap,
        enumerable: false,  // as default .constructor is
        configurable: true,
        writable: true
      });
    })();
  } else {
    // There is no host WeakMap, so we must use the emulation.

    // Emulated WeakMaps are incompatible with native proxies (because proxies
    // can observe the hidden name), so we must disable Proxy usage (in
    // ArrayLike and Domado, currently).
    if (typeof Proxy !== 'undefined') {
      Proxy = undefined;
    }

    module.exports = OurWeakMap;
  }
})();


/***/ }),

/***/ "mFR0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "odPn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ouFg":
/***/ (function(module, exports) {

module.exports = extend

var hasOwnProperty = Object.prototype.hasOwnProperty;

function extend(target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i]

        for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
                target[key] = source[key]
            }
        }
    }

    return target
}


/***/ }),

/***/ "rD3X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "svXm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tBbN":
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.fit=t():e.fit=t()}(this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={exports:{},id:r,loaded:!1};return e[r].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var n={};return t.m=e,t.c=n,t.p="",t(0)}([function(e,t,n){e.exports=n(57)},function(e,t,n){"use strict";e.exports=n(92)},function(e,t,n){"use strict";function r(e,t,n,r,a,u,i,l){if(o(t),!e){var c;if(void 0===t)c=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var s=[n,r,a,u,i,l],f=0;c=new Error(t.replace(/%s/g,function(){return s[f++]})),c.name="Invariant Violation"}throw c.framesToPop=1,c}}var o=function(e){};e.exports=r},function(e,t,n){"use strict";function r(e){return void 0!==e.ref}function o(e){return void 0!==e.key}var a=n(6),u=n(22),i=(n(5),n(25),Object.prototype.hasOwnProperty),l=n(23),c={key:!0,ref:!0,__self:!0,__source:!0},s=function(e,t,n,r,o,a,u){var i={$$typeof:l,type:e,key:t,ref:n,props:u,_owner:a};return i};s.createElement=function(e,t,n){var a,l={},f=null,p=null,d=null,h=null;if(null!=t){r(t)&&(p=t.ref),o(t)&&(f=""+t.key),d=void 0===t.__self?null:t.__self,h=void 0===t.__source?null:t.__source;for(a in t)i.call(t,a)&&!c.hasOwnProperty(a)&&(l[a]=t[a])}var v=arguments.length-2;if(1===v)l.children=n;else if(v>1){for(var y=Array(v),m=0;m<v;m++)y[m]=arguments[m+2];l.children=y}if(e&&e.defaultProps){var b=e.defaultProps;for(a in b)void 0===l[a]&&(l[a]=b[a])}return s(e,f,p,d,h,u.current,l)},s.createFactory=function(e){var t=s.createElement.bind(null,e);return t.type=e,t},s.cloneAndReplaceKey=function(e,t){var n=s(e.type,t,e.ref,e._self,e._source,e._owner,e.props);return n},s.cloneElement=function(e,t,n){var l,f=a({},e.props),p=e.key,d=e.ref,h=e._self,v=e._source,y=e._owner;if(null!=t){r(t)&&(d=t.ref,y=u.current),o(t)&&(p=""+t.key);var m;e.type&&e.type.defaultProps&&(m=e.type.defaultProps);for(l in t)i.call(t,l)&&!c.hasOwnProperty(l)&&(void 0===t[l]&&void 0!==m?f[l]=m[l]:f[l]=t[l])}var b=arguments.length-2;if(1===b)f.children=n;else if(b>1){for(var g=Array(b),_=0;_<b;_++)g[_]=arguments[_+2];f.children=g}return s(e.type,p,d,h,v,y,f)},s.isValidElement=function(e){return"object"==typeof e&&null!==e&&e.$$typeof===l},e.exports=s},function(e,t){"use strict";function n(e){return function(){return e}}var r=function(){};r.thatReturns=n,r.thatReturnsFalse=n(!1),r.thatReturnsTrue=n(!0),r.thatReturnsNull=n(null),r.thatReturnsThis=function(){return this},r.thatReturnsArgument=function(e){return e},e.exports=r},function(e,t,n){"use strict";var r=n(4),o=r;e.exports=o},function(e,t){/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
"use strict";function n(e){if(null===e||void 0===e)throw new TypeError("Object.assign cannot be called with null or undefined");return Object(e)}function r(){try{if(!Object.assign)return!1;var e=new String("abc");if(e[5]="de","5"===Object.getOwnPropertyNames(e)[0])return!1;for(var t={},n=0;n<10;n++)t["_"+String.fromCharCode(n)]=n;var r=Object.getOwnPropertyNames(t).map(function(e){return t[e]});if("0123456789"!==r.join(""))return!1;var o={};return"abcdefghijklmnopqrst".split("").forEach(function(e){o[e]=e}),"abcdefghijklmnopqrst"===Object.keys(Object.assign({},o)).join("")}catch(e){return!1}}var o=Object.getOwnPropertySymbols,a=Object.prototype.hasOwnProperty,u=Object.prototype.propertyIsEnumerable;e.exports=r()?Object.assign:function(e,t){for(var r,i,l=n(e),c=1;c<arguments.length;c++){r=Object(arguments[c]);for(var s in r)a.call(r,s)&&(l[s]=r[s]);if(o){i=o(r);for(var f=0;f<i.length;f++)u.call(r,i[f])&&(l[i[f]]=r[i[f]])}}return l}},function(e,t){"use strict";function n(e){for(var t=arguments.length-1,n="Minified React error #"+e+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant="+e,r=0;r<t;r++)n+="&args[]="+encodeURIComponent(arguments[r+1]);n+=" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";var o=new Error(n);throw o.name="Invariant Violation",o.framesToPop=1,o}e.exports=n},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=Object.keys(e);return t.length?t.sort(function(t,n){return e[n].sortId-e[t].sortId}):t}function a(e){var t="translateY("+p*e+"px)";return{transform:t}}function u(e){var t=Object.keys(e).length;return{height:p*t+"px"}}function i(e){var t=e.attachments,n=e.onAbort,r=e.autoGrow,i=o(t),l=u(t),s="fit-attachment-list"+(r?" fixed":"");return i.length?c.default.createElement("ul",{className:s,style:l},i.map(function(e,r){var o=a(r);return c.default.createElement(f.default,{key:e,style:o,file:t[e],onAbort:n})})):null}Object.defineProperty(t,"__esModule",{value:!0});var l=n(1),c=r(l);n(66);var s=n(26),f=r(s),p=50;t.default=i},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.name,n=e.onAttach,r=e.text,o=e.isSingle,a="fit-btn-attachment",i=!o;return r&&(a+=" btn-standard btn-white-grad"),u.default.createElement("label",{className:a},r,u.default.createElement("input",{type:"file",name:t,onChange:function(e){return n(e.target.files)},multiple:i}))}Object.defineProperty(t,"__esModule",{value:!0});var a=n(1),u=r(a);n(69),o.propTypes={name:u.default.PropTypes.string.isRequired,onAttach:u.default.PropTypes.func.isRequired,text:u.default.PropTypes.string,isSingle:u.default.PropTypes.bool},t.default=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.error,n=e.icon;if(!t||0===Object.keys(t).length||!t.title&&!t.message)return null;var r=n?" icon ":"";return u.default.createElement("div",{className:"fit-simple-error "+r},t.title&&u.default.createElement("strong",null,t.title),t.message&&u.default.createElement("small",null,t.message))}Object.defineProperty(t,"__esModule",{value:!0});var a=n(1),u=r(a);n(75),t.default=o},function(e,t){"use strict";function n(e){switch(e){case"small":return"btn-standard";case"medium":return"btn-lrg-standard lesspad";case"large":return"btn-lrg-standard";case"full-width":return"btn-lrg-standard full-width";default:return"btn-standard"}}Object.defineProperty(t,"__esModule",{value:!0}),t.getSizeClass=n},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){if(!e.text)return e.children;var t={"data-hint":e.text||"",className:"hint--"+(e.position||"top")};return u.default.createElement("span",t,e.children)}Object.defineProperty(t,"__esModule",{value:!0});var a=n(1),u=r(a);t.default=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function u(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var l=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},c=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(1),f=r(s),p=n(10),d=r(p),h=function(e){function t(e){a(this,t);var n=u(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.state={validationError:!1},n.handleChange=n.handleChange.bind(n),n}return i(t,e),c(t,[{key:"handleChange",value:function(e){var t=this,n=e.target.value;this.setState(function(){var e=t.props.validate&&t.props.validate(n);return{validationError:e}})}},{key:"render",value:function(){var e=this.state.validationError,t=this.props,n=t.id,r=t.label,a=t.prefix,u=t.suffix,i=o(t,["id","label","prefix","suffix"]);return f.default.createElement("div",{className:"fit-input"},f.default.createElement("label",{htmlFor:n},r,f.default.createElement("div",{className:"input-wrapper","data-prefix":a,"data-suffix":u},f.default.createElement("input",l({onChange:this.handleChange,className:e?"with-error":""},i)))),!!e&&f.default.createElement(d.default,{error:e}))}}]),t}(s.Component);t.default=h},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.updateCurrentPage,n=e.currentPage,r=e.totalPages,o=[],a=1;for(a;a<=r;a++)a===n?o.push(i.default.createElement("a",{href:"#",className:"current-page",key:a},a)):o.push(i.default.createElement("a",{href:"#",onClick:function(){return t(a)},key:a},a));return i.default.createElement("ul",null,o)}function a(e){var t=e.updateCurrentPage,n=e.currentPage,r=e.totalPages;return r<=1?null:i.default.createElement("nav",{className:"pagination fit-pagination"},i.default.createElement("div",{className:"pagination-range"},i.default.createElement(o,{updateCurrentPage:t,currentPage:n,totalPages:r})))}Object.defineProperty(t,"__esModule",{value:!0});var u=n(1),i=r(u);n(74),t.default=a},function(e,t){"use strict";function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"";return{title:e,message:t}}Object.defineProperty(t,"__esModule",{value:!0}),t.default=n},function(e,t,n){"use strict";function r(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}function o(e){return e&&e.__esModule?e:{default:e}}function a(e){var t=e.icon,n=e.width,r=void 0===n?20:n,o=e.height,a=void 0===o?20:o,u=e.color,l=void 0===u?"black":u;if(!t)return null;var s="fit-svg-icon "+t+" "+l;return i.default.createElement("svg",{className:s,viewBox:"0 0 1792 1792",xmlns:"http://www.w3.org/2000/svg",width:r,height:a},i.default.createElement("path",{d:c[t]}))}Object.defineProperty(t,"__esModule",{value:!0});var u=n(1),i=o(u);n(77);var l=n(43),c=r(l);t.default=a},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function i(e){var t=e.extensions;return t?f.default.createElement("div",{className:"textarea-extensions"},t):null}function l(e){var t=e.label;return t?f.default.createElement("div",null,t):null}Object.defineProperty(t,"__esModule",{value:!0});var c=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(1),f=r(s),p=n(30),d=r(p),h=n(10),v=r(h);n(80);var y=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1;return function(){return e++}},m=y(),b=function(e){function t(e){o(this,t);var n=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.state={validationError:!1,value:n.props.value||""},n.id="fit-textarea-"+m(),n.handleChange=n.handleChange.bind(n),n}return u(t,e),c(t,[{key:"componentWillReceiveProps",value:function(e){var t=this.state.value,n=e.value||t,r=n===t?t:n;this.setState({value:r})}},{key:"handleChange",value:function(){var e=this,t=this.textarea.value;this.setState(function(n){var r=e.reachedMaxLength(t)?n.value:t;return e.props.onChange&&e.props.onChange(r),{value:r,validationError:e.props.validate&&e.props.validate(t)}})}},{key:"reachedMaxLength",value:function(e){var t=this.props.maxLength;return!!t&&e.length>t}},{key:"render",value:function(){var e=this,t=this.state,n=t.validationError,r=t.value,o=this.props,a=o.maxLength,u=o.name,c=o.children,s=o.placeholder,p=o.isInvalid,h=o.label,y=o.hideCharCount,m=o.onBlur,b=r.length,g=n||p?"invalid":"",_="fit-textarea"+(h?" has-label":"");return f.default.createElement("div",{className:_},f.default.createElement("textarea",{name:u,className:g,id:this.id,value:r,placeholder:s,onChange:this.handleChange,onBlur:m?m:function(){return!0},ref:function(t){return e.textarea=t}}),f.default.createElement("label",{htmlFor:this.id},f.default.createElement(l,{label:h})),f.default.createElement("footer",null,!y&&f.default.createElement(d.default,{currentCount:b,maxCount:a}),f.default.createElement(i,{extensions:c})),!!n&&f.default.createElement(v.default,{error:n}))}}]),t}(s.Component);t.default=b},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(60),a=r(o);t.default=a.default},function(e,t,n){"use strict";var r={};e.exports=r},function(e,t){"use strict";var n="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=n},function(e,t,n){"use strict";function r(e,t,n){this.props=e,this.context=t,this.refs=c,this.updater=n||l}function o(e,t,n){this.props=e,this.context=t,this.refs=c,this.updater=n||l}function a(){}var u=n(7),i=n(6),l=n(24),c=(n(25),n(19));n(2),n(99);r.prototype.isReactComponent={},r.prototype.setState=function(e,t){"object"!=typeof e&&"function"!=typeof e&&null!=e?u("85"):void 0,this.updater.enqueueSetState(this,e),t&&this.updater.enqueueCallback(this,t,"setState")},r.prototype.forceUpdate=function(e){this.updater.enqueueForceUpdate(this),e&&this.updater.enqueueCallback(this,e,"forceUpdate")};a.prototype=r.prototype,o.prototype=new a,o.prototype.constructor=o,i(o.prototype,r.prototype),o.prototype.isPureReactComponent=!0,e.exports={Component:r,PureComponent:o}},function(e,t){"use strict";var n={current:null};e.exports=n},function(e,t){"use strict";var n="function"==typeof Symbol&&Symbol.for&&Symbol.for("react.element")||60103;e.exports=n},function(e,t,n){"use strict";function r(e,t){}var o=(n(5),{isMounted:function(e){return!1},enqueueCallback:function(e,t){},enqueueForceUpdate:function(e){r(e,"forceUpdate")},enqueueReplaceState:function(e,t){r(e,"replaceState")},enqueueSetState:function(e,t){r(e,"setState")}});e.exports=o},function(e,t,n){"use strict";var r=!1;e.exports=r},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.onAbort,n=e.file,r=e.style,o=void 0===r?{}:r,a=n.error,i=n.extension,c=n.progress,s=n.fileName,f=n.fileSize,p=n.loaded,d=p===!0?" done":"",h="",v=f;a&&(h=" file-error",v=a);var y="fit-attachment"+d+h;return u.default.createElement("li",{style:o,className:y},u.default.createElement("div",{className:"file-progress"},u.default.createElement(l.default,{progress:c})),u.default.createElement("div",{className:"file-info"},u.default.createElement("strong",null,u.default.createElement("span",{className:"name"},s),u.default.createElement("span",null,i)),u.default.createElement("small",null,v)),u.default.createElement("a",{href:"#!",className:"abort",onClick:function(){return t(n.id)}}))}Object.defineProperty(t,"__esModule",{value:!0});var a=n(1),u=r(a),i=n(18),l=r(i);n(65),t.default=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.src,n=e.size,r=void 0===n?24:n;return t?(t=t.startsWith("http")?'<img src="'+t+'"/>':t,u.default.createElement("span",{className:"fit-avatar s"+r,dangerouslySetInnerHTML:{__html:t}})):null}Object.defineProperty(t,"__esModule",{value:!0});var a=n(1),u=r(a);n(67),t.default=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.index,n=e.title,r=e.url,o=e.crumbClass;return r?u.default.createElement("a",{href:r,"data-index":t,className:o},n):u.default.createElement("span",{"data-index":t,className:o},n)}Object.defineProperty(t,"__esModule",{value:!0});var a=n(1),u=r(a);n(68);var i=function(e){var t=e.crumbsList,n=e.currentCrumb,r=void 0===n?"1":n;return t.length?u.default.createElement("ul",{className:"fit-breadcrumbs-list"},t.map(function(e,t){var n=t+1,a=n===parseInt(r,10),i=a?"current":null,l=a?null:e.url;return u.default.createElement("li",{key:t},u.default.createElement(o,{index:n,title:e.title,url:l,crumbClass:i}))})):null};i.propTypes={crumbsList:u.default.PropTypes.array.isRequired},t.default=i},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function a(e){var t=e.text,n=e.theme,r=e.size,a=e.type,i=e.disabled,s=e.inProgress,f=e.className,p=o(e,["text","theme","size","type","disabled","inProgress","className"]),d=(0,c.getSizeClass)(r),h=s?"in-progress":"",v=i?"disabled":"",y=[d,n,h,v,f].filter(function(e){return!!e}).join(" ");return l.default.createElement("button",u({className:y,type:a,disabled:i},p),t)}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},i=n(1),l=r(i),c=n(11);a.defaultProps={size:"small",text:"",theme:"",type:"button",disabled:!1,inProgress:!1,className:""},t.default=a},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.currentCount,n=void 0===t?0:t,r=e.maxCount,o=void 0===r?0:r;return u.default.createElement("span",{className:"fit-char-count"},u.default.createElement("strong",null,n)," / ",u.default.createElement("span",{className:"max"},o))}Object.defineProperty(t,"__esModule",{value:!0});var a=n(1),u=r(a);o.propTypes={currentCount:u.default.PropTypes.number,maxCount:u.default.PropTypes.number},t.default=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function a(e){var t=e.caption,n=o(e,["caption"]);return l.default.createElement("label",{className:"fit-checkbox fake-check-black check-text"},l.default.createElement("input",u({type:"checkbox"},n)),l.default.createElement("span",{className:"chk-img"}),t)}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},i=n(1),l=r(i);a.propTypes={caption:l.default.PropTypes.any},t.default=a},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){function t(e){var t=c,n=t.checked;n&&(e&&e.preventDefault(),t.checked=!1)}var n=e.group,r=e.children,o=l(),a="collapsable-"+n,i=a+"-"+o,c=void 0;return u.default.createElement("section",{className:"fit-collapsable"},u.default.createElement("input",{type:"radio",name:a,id:i,ref:function(e){return c=e}}),u.default.createElement("label",{htmlFor:i,onClick:t},r[0]()),u.default.createElement("article",null,r[1](t)))}Object.defineProperty(t,"__esModule",{value:!0});var a=n(1),u=r(a);n(70);var i=function(e){return function(){return e++}},l=i(1);t.default=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function u(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var l=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},c=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(1),f=r(s),p=n(11),d=function(e){function t(e){a(this,t);var n=u(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.state={disabled:n.props.disabled||!1,inProgress:n.props.inProgress||!1},n}return i(t,e),c(t,[{key:"render",value:function(){var e=this.state,t=e.disabled,n=e.inProgress,r=this.props,a=r.text,u=void 0===a?"":a,i=r.theme,c=void 0===i?"":i,s=r.size,d=r.href,h=void 0===d?"#":d,v=o(r,["text","theme","size","href"]),y=n?" in-progress":"",m=t?" disabled":"",b=(0,p.getSizeClass)(s),g=b+" "+c+" "+m+" "+y;return f.default.createElement("a",l({href:h,className:g},v),u)}}]),t}(s.Component);t.default=d},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var i=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},l=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),c=n(1),s=r(c),f=n(13),p=r(f),d=n(15),h=r(d);n(71);var v=function(e){function t(e){o(this,t);var n=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.inputValidation=n.inputValidation.bind(n),n}return u(t,e),l(t,[{key:"inputValidation",value:function(e){return""===e||Number(e)>=0?this.props.validate&&this.props.validate(e):this.props.defaultError||(0,h.default)()}},{key:"render",value:function(){var e=this.props.symbol;return s.default.createElement("div",{className:"fit-currency"},s.default.createElement(p.default,i({},this.props,{validate:this.inputValidation,prefix:e})))}}]),t}(c.Component);t.default=v},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(1),c=r(l),s=n(14),f=r(s);n(72);var p=function(e){function t(e){o(this,t);var n=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.state={currentPage:e.currentPage||1,perPage:e.perPage||2},n.updateCurrentPage=n.updateCurrentPage.bind(n),n}return u(t,e),i(t,[{key:"updateCurrentPage",value:function(e){this.setState({currentPage:e})}},{key:"filterPerPage",value:function(e){var t=this.state,n=t.perPage,r=t.currentPage,o=n*r,a=(r-1)*n;return e.slice(a,o)}},{key:"render",value:function(){var e=this.state,t=e.currentPage,n=e.perPage,r=this.props,o=r.tableHeader,a=r.data,u=Math.ceil(a.length/n);return c.default.createElement("table",{className:"easy-table"},c.default.createElement("thead",null,c.default.createElement("tr",null,o.map(function(e,t){return c.default.createElement("th",{key:t},e.title)}))),c.default.createElement("tbody",null,this.filterPerPage(a).map(function(e,t){return c.default.createElement("tr",{key:t},o.map(function(t,n){return c.default.createElement("td",{key:n},"actions"===t.assignTo&&t.actions(e.id),"actions"!==t.assignTo&&e[t.assignTo])}))})),u&&c.default.createElement("tfoot",null,c.default.createElement("tr",null,c.default.createElement("td",{colSpan:o.length},c.default.createElement(f.default,{totalPages:u,currentPage:t,updateCurrentPage:this.updateCurrentPage})))))}}]),t}(l.Component);t.default=p},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){function t(e){e.target.parentElement.remove(),o&&o()}var n=e.theme,r=e.title,o=e.callback,a=e.closeButton,i=e.children;return u.default.createElement("div",{className:"fit-pagealert "+n},a&&u.default.createElement("a",{href:"#",className:"btn-close",onClick:t},"×"),u.default.createElement("i",{className:"icon"}),u.default.createElement("div",{className:"content-wrapper"},u.default.createElement("h3",null,r),u.default.createElement("div",{className:"content"},i)))}Object.defineProperty(t,"__esModule",{value:!0});var a=n(1),u=r(a);n(73),o.propTypes={theme:u.default.PropTypes.string.isRequired,title:u.default.PropTypes.string.isRequired,callback:u.default.PropTypes.func,closeButton:u.default.PropTypes.bool},t.default=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function a(e){var t=e.caption,n=o(e,["caption"]);return l.default.createElement("label",{className:"fit-radio fake-radio-black radio-text"},l.default.createElement("input",u({type:"radio"},n)),l.default.createElement("span",{className:"radio-img"}),t)}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},i=n(1),l=r(i);a.propTypes={caption:l.default.PropTypes.any},t.default=a},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){for(var t=e.value,n=void 0===t?0:t,r=e.max,o=void 0===r?5:r,u=e.shape,l=void 0===u?"star":u,s=e.width,f=void 0===s?20:s,p=e.height,d=void 0===p?20:p,h=e.color,v=void 0===h?"black":h,y={color:v,width:f,height:d},m=Math.round(2*n)/2,b=[],g=0;g<o;g++){var _="full_"+l;g+.5===m?_="o_half_"+l:g>=Math.floor(m)&&(_="o_"+l),b.push(i.default.createElement(c.default,a({},y,{icon:_})))}return i.default.createElement("div",{className:"fit-rating"},b)}Object.defineProperty(t,"__esModule",{value:!0});var a=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=n(1),i=r(u),l=n(16),c=r(l);t.default=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function a(e){var t=e.children,n=e.label,r=o(e,["children","label"]);return i.default.createElement("label",null,n,i.default.createElement("select",r,t))}Object.defineProperty(t,"__esModule",{value:!0});var u=n(1),i=r(u);t.default=a},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function a(e){var t=e.children,n=o(e,["children"]);return i.default.createElement("option",n,t)}Object.defineProperty(t,"__esModule",{value:!0});var u=n(1),i=r(u);t.default=a},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(1),c=r(l),s=n(8),f=r(s),p=n(9),d=r(p),h=n(12),v=r(h),y=function(e){function t(e){o(this,t);var n=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.state={attachments:n.props.attachments||{}},n}return u(t,e),i(t,[{key:"componentWillReceiveProps",value:function(e){this.setState({attachments:e.attachments||{}})}},{key:"render",value:function(){var e=this.state.attachments,t=this.props,n=t.name,r=t.onAttach,o=t.onAbort,a=t.text,u=t.hint;return c.default.createElement("div",{className:"fit-simple-uploader"},c.default.createElement(v.default,u,c.default.createElement(d.default,{name:n,text:a,onAttach:r})),c.default.createElement(f.default,{attachments:e,onAbort:o,autoGrow:!0}))}}]),t}(l.Component);t.default=y},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function a(e){var t=e.children,n=e.caption,r=e.classes,a=o(e,["children","caption","classes"]),i=r?" "+r:"";return l.default.createElement("span",u({className:"fit-status"+i},a),n?n:t)}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},i=n(1),l=r(i);n(76),t.default=a},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.refresh=t.clock_o=t.check=t.o_heart=t.full_heart=t.o_half_star=t.o_star=t.full_star=void 0;var o=n(47),a=r(o),u=n(50),i=r(u),l=n(48),c=r(l),s=n(46),f=r(s),p=n(49),d=r(p),h=n(44),v=r(h),y=n(45),m=r(y),b=n(51),g=r(b);t.full_star=a.default,t.o_star=i.default,t.o_half_star=c.default,t.full_heart=f.default,t.o_heart=d.default,t.check=v.default,t.clock_o=m.default,t.refresh=g.default},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n="M1671 566q0 40-28 68l-724 724-136 136q-28 28-68 28t-68-28l-136-136-362-362q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 295 656-657q28-28 68-28t68 28l136 136q28 28 28 68z";t.default=n},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n="M1024 544v448q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h224v-352q0-14 9-23t23-9h64q14 0 23 9t9 23zm416 352q0-148-73-273t-198-198-273-73-273 73-198 198-73 273 73 273 198 198 273 73 273-73 198-198 73-273zm224 0q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z";t.default=n},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n="M896 1664q-26 0-44-18l-624-602q-10-8-27.5-26t-55.5-65.5-68-97.5-53.5-121-23.5-138q0-220 127-344t351-124q62 0 126.5 21.5t120 58 95.5 68.5 76 68q36-36 76-68t95.5-68.5 120-58 126.5-21.5q224 0 351 124t127 344q0 221-229 450l-623 600q-18 18-44 18z";t.default=n},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n="M1728 647q0 22-26 48l-363 354 86 500q1 7 1 20 0 21-10.5 35.5t-30.5 14.5q-19 0-40-12l-449-236-449 236q-22 12-40 12-21 0-31.5-14.5t-10.5-35.5q0-6 2-20l86-500-364-354q-25-27-25-48 0-37 56-46l502-73 225-455q19-41 49-41t49 41l225 455 502 73q56 9 56 46z";t.default=n},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n="M1250 957l257-250-356-52-66-10-30-60-159-322v963l59 31 318 168-60-355-12-66zm452-262l-363 354 86 500q5 33-6 51.5t-34 18.5q-17 0-40-12l-449-236-449 236q-23 12-40 12-23 0-34-18.5t-6-51.5l86-500-364-354q-32-32-23-59.5t54-34.5l502-73 225-455q20-41 49-41 28 0 49 41l225 455 502 73q45 7 54 34.5t-24 59.5z";t.default=n},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n="M1664 596q0-81-21.5-143t-55-98.5-81.5-59.5-94-31-98-8-112 25.5-110.5 64-86.5 72-60 61.5q-18 22-49 22t-49-22q-24-28-60-61.5t-86.5-72-110.5-64-112-25.5-98 8-94 31-81.5 59.5-55 98.5-21.5 143q0 168 187 355l581 560 580-559q188-188 188-356zm128 0q0 221-229 450l-623 600q-18 18-44 18t-44-18l-624-602q-10-8-27.5-26t-55.5-65.5-68-97.5-53.5-121-23.5-138q0-220 127-344t351-124q62 0 126.5 21.5t120 58 95.5 68.5 76 68q36-36 76-68t95.5-68.5 120-58 126.5-21.5q224 0 351 124t127 344z";t.default=n},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n="M1201 1004l306-297-422-62-189-382-189 382-422 62 306 297-73 421 378-199 377 199zm527-357q0 22-26 48l-363 354 86 500q1 7 1 20 0 50-41 50-19 0-40-12l-449-236-449 236q-22 12-40 12-21 0-31.5-14.5t-10.5-35.5q0-6 2-20l86-500-364-354q-25-27-25-48 0-37 56-46l502-73 225-455q19-41 49-41t49 41l225 455 502 73q56 9 56 46z";t.default=n},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n="M1639 1056q0 5-1 7-64 268-268 434.5t-478 166.5q-146 0-282.5-55t-243.5-157l-129 129q-19 19-45 19t-45-19-19-45v-448q0-26 19-45t45-19h448q26 0 45 19t19 45-19 45l-137 137q71 66 161 102t187 36q134 0 250-65t186-179q11-17 53-117 8-23 30-23h192q13 0 22.5 9.5t9.5 22.5zm25-800v448q0 26-19 45t-45 19h-448q-26 0-45-19t-19-45 19-45l138-138q-148-137-349-137-134 0-250 65t-186 179q-11 17-53 117-8 23-30 23h-199q-13 0-22.5-9.5t-9.5-22.5v-7q65-268 270-434.5t480-166.5q146 0 284 55.5t245 156.5l130-129q19-19 45-19t45 19 19 45z";
t.default=n},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.url,n=void 0===t?"#!":t,r=e.text;return r?u.default.createElement("a",{href:n,className:"fit-tag"},r):null}Object.defineProperty(t,"__esModule",{value:!0});var a=n(1),u=r(a);n(78),t.default=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.tags,n=void 0===t?[]:t,r="fit-tag-list";return u.default.createElement("ul",{className:r},n.map(function(e,t){return u.default.createElement("li",{key:t},u.default.createElement(l.default,{text:e.text,url:e.url}))}))}Object.defineProperty(t,"__esModule",{value:!0});var a=n(1),u=r(a),i=n(52),l=r(i);n(79),t.default=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var i=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},l=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),c=n(1),s=r(c),f=n(17),p=r(f),d=n(8),h=r(d),v=n(9),y=r(v),m=n(12),b=r(m);n(81);var g=function(e){function t(e){o(this,t);var n=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.state={attachments:e.attachments||{},value:e.value||""},n}return u(t,e),l(t,[{key:"componentWillReceiveProps",value:function(e){var t=this.state.value,n=e.value||t,r=n===t?t:n;this.setState({attachments:e.attachments||{},value:r})}},{key:"render",value:function(){var e=this,t=this.state.attachments,n=this.props,r=n.attachmentName,o=n.onAttach,a=n.onAbort,u=n.hint,l=n.children,c=Object.keys(t).length>0,f=c?" has-attachments":"";return s.default.createElement("div",{className:"fit-textarea-attachment"+f},s.default.createElement(p.default,i({},this.props,{ref:function(t){return t?e.textarea=t.textarea:null}}),l,s.default.createElement(b.default,u,s.default.createElement(y.default,{name:r,onAttach:o}))),s.default.createElement(h.default,{attachments:t,onAbort:a}))}}]),t}(c.Component);t.default=g},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function a(e){var t=e.toggleName,n=o(e,["toggleName"]);return l.default.createElement("span",{className:"toggle-wrapper"},l.default.createElement("label",{htmlFor:"toggle"+t},l.default.createElement("input",u({type:"checkbox",id:"toggle"+t},n)),l.default.createElement("span",{className:"fake-toggle"})))}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},i=n(1),l=r(i);n(82),a.propTypes={toggleName:l.default.PropTypes.string.isRequired,checked:l.default.PropTypes.bool,defaultChecked:l.default.PropTypes.bool,onChange:l.default.PropTypes.func},t.default=a},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(1),c=(r(l),n(89)),s=r(c),f=n(62),p=r(f),d=n(63),h=r(d),v=function(e){function t(e){o(this,t);var n=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e)),r={isActive:n.props.defaultIsActive,inputValue:n.props.defaultInputValue,selectedOption:n.props.defaultSelectedOption,activeOptionIndex:0};return!r.selectedOption||"string"==typeof r.selectedOption&&"number"==typeof r.selectedOption||(r.inputValue=n.props.optionToString(r.selectedOption)),n.controlledOptions=[],n.getOptionProps=n.getOptionProps.bind(n),n.getTextInputProps=n.getTextInputProps.bind(n),n.getMenuButtonProps=n.getMenuButtonProps.bind(n),n.handleInputChange=n.handleInputChange.bind(n),n.handleInputKeyUp=n.handleInputKeyUp.bind(n),n.toggleActive=n.toggleActive.bind(n),n.setActiveFalse=n.setActive.bind(n,!1),n.setActiveTrue=n.setActive.bind(n,!0),n.state=r,n}return u(t,e),i(t,[{key:"componentWillUpdate",value:function(){this.resetControlledOptions()}},{key:"componentDidUpdate",value:function(e,t){(0,h.default)(this.state.selectedOption,t.selectedOption)||this.props.onChange(this.state.selectedOption)}},{key:"resetControlledOptions",value:function(){this.controlledOptions=[]}},{key:"getOptionAtIndex",value:function(e){return this.controlledOptions[e]}},{key:"setActive",value:function(e){this.setState(function(t){return Object.assign({},t,{isActive:e})})}},{key:"toggleActive",value:function(){this.setState(function(e){return Object.assign({},e,{isActive:!e.isActive})})}},{key:"handleInputChange",value:function(e){var t=e.target.value;this.setState(function(e){return Object.assign({},e,{isActive:!0,inputValue:t})})}},{key:"handleInputKeyUp",value:function(e){switch(e.which){case 13:var t=this.getOptionAtIndex(this.state.activeOptionIndex),n="string"==typeof t?t:this.props.optionToString(t);this.setState(function(e){return Object.assign({},e,{isActive:!1,selectedOption:t,inputValue:n})});break;case 38:this.setState(function(e){return Object.assign({},e,{activeOptionIndex:e.activeOptionIndex-1})});break;case 40:this.setState(function(e){return Object.assign({},e,{activeOptionIndex:e.activeOptionIndex+1})})}}},{key:"createOptionMouseEnterHandler",value:function(e){var t=this;return function(){t.setState(function(t){return Object.assign({},t,{activeOptionIndex:e})})}}},{key:"createOptionClickHandler",value:function(e){var t=this;return function(){var n="string"==typeof e?e:t.props.optionToString(e);t.setState(function(t){return Object.assign({},t,{isActive:!1,selectedOption:e,inputValue:n})})}}},{key:"getTextInputProps",value:function(e){var t=this,n={type:"text"},r={onFocus:(0,p.default)(e.onFocus,this.setActiveTrue),onBlur:(0,p.default)(e.onBlur,function(){return setTimeout(t.setActiveFalse,150)}),onChange:(0,p.default)(e.onChange,this.handleInputChange),onKeyUp:(0,p.default)(e.onKeyUp,this.handleInputKeyUp)};return Object.assign({},n,e,r)}},{key:"getOptionProps",value:function(e){var t=e.option,n=this.controlledOptions.length,r={onMouseEnter:(0,p.default)(e.mouseEnter,this.createOptionMouseEnterHandler(n)),onClick:(0,p.default)(e.onClick,this.createOptionClickHandler(t))};if(!t)throw new Error("passing the option property to getOptionProps is required");return delete e.option,this.controlledOptions.push(t),Object.assign({},e,r)}},{key:"getMenuButtonProps",value:function(e){var t={onClick:(0,p.default)(e.onClick,this.toggleActive)};return Object.assign({},e,t)}},{key:"getStateAndHelpers",value:function(){var e=this.state,t=e.isActive,n=e.inputValue,r=e.selectedOption,o=e.activeOptionIndex,a=this.getTextInputProps,u=this.getOptionProps,i=this.getMenuButtonProps;return{isActive:t,inputValue:n,selectedOption:r,getTextInputProps:a,getMenuButtonProps:i,getOptionProps:u,activeOptionIndex:o}}},{key:"render",value:function e(){var t=this.props,e=t.render,n=t.children;if("function"!=typeof e&&"function"!=typeof n)throw new Error("you must provide either a child function or a render property to typeaheadselect");var r=n||e,o=this.getStateAndHelpers();return r(o)}}]),t}(l.Component);v.propTypes={optionToString:s.default.func,onChange:s.default.func,defaultIsActive:s.default.bool,defaultInputValue:s.default.string,defaultSelectedOption:s.default.any},v.defaultProps={optionToString:function(e){return e},onChange:function(e){return e},defaultIsActive:!1,defaultInputValue:""},t.default=v},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.TypeaheadSelect=t.Status=t.TagList=t.Rating=t.SvgIcon=t.ProgressRound=t.ProgressBar=t.Input=t.ToggleButton=t.TextareaAttachment=t.TextaraAttachment=t.Textarea=t.Breadcrumbs=t.PageAlert=t.Pagination=t.EasyTable=t.SimpleUploader=t.SimpleError=t.Select=t.Option=t.ErrorMessage=t.Radio=t.Checkbox=t.Collapsable=t.Currency=t.Cta=t.ButtonAttachment=t.Button=t.Avatar=t.AttachmentList=void 0;var o=n(1),a=(r(o),n(8)),u=r(a),i=n(27),l=r(i),c=n(29),s=r(c),f=n(9),p=r(f),d=n(33),h=r(d),v=n(34),y=r(v),m=n(54),b=r(m),g=n(15),_=r(g),O=n(55),P=r(O),E=n(32),j=r(E),x=n(31),w=r(x),M=n(14),k=r(M),C=n(37),T=r(C),N=n(40),A=r(N),S=n(39),q=r(S),I=n(10),R=r(I),D=n(41),F=r(D),B=n(36),z=r(B),Y=n(28),U=r(Y),V=n(17),W=r(V),L=n(13),G=r(L),K=n(61),H=n(35),$=r(H),J=n(16),Q=r(J),X=n(38),Z=r(X),ee=n(53),te=r(ee),ne=n(42),re=r(ne),oe=n(56),ae=r(oe),ue=b.default;t.AttachmentList=u.default,t.Avatar=l.default,t.Button=s.default,t.ButtonAttachment=p.default,t.Cta=h.default,t.Currency=y.default,t.Collapsable=j.default,t.Checkbox=w.default,t.Radio=T.default,t.ErrorMessage=_.default,t.Option=A.default,t.Select=q.default,t.SimpleError=R.default,t.SimpleUploader=F.default,t.EasyTable=$.default,t.Pagination=k.default,t.PageAlert=z.default,t.Breadcrumbs=U.default,t.Textarea=W.default,t.TextaraAttachment=ue,t.TextareaAttachment=b.default,t.ToggleButton=P.default,t.Input=G.default,t.ProgressBar=K.ProgressBar,t.ProgressRound=K.ProgressRound,t.SvgIcon=Q.default,t.Rating=Z.default,t.TagList=te.default,t.Status=re.default,t.TypeaheadSelect=ae.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.value,n=e.max,r=void 0===n?1:n,o=t/r*100;return u.default.createElement("div",{className:"fit-progress-bar"},u.default.createElement("span",{className:"fill",style:{width:o+"%"}}))}Object.defineProperty(t,"__esModule",{value:!0});var a=n(1),u=r(a);n(83),o.propTypes={value:u.default.PropTypes.number,max:u.default.PropTypes.number},t.default=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(58),a=r(o);t.default=a.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){var t=e.progress,n=void 0===t?0:t,r=204,o={strokeDasharray:r,strokeDashoffset:r},a=function(e){var t=r*e/100;return Object.assign({},o,{strokeDashoffset:r-t})},l=a(n);return u.default.createElement("div",{className:"fit-round-progress"},u.default.createElement("div",{className:"back-layer"}),u.default.createElement("svg",{viewBox:"-1 -1 71 71"},u.default.createElement("path",{d:i,style:l})))}Object.defineProperty(t,"__esModule",{value:!0});var a=n(1),u=r(a);n(84);var i="m35,2.5c17.955803,0 32.5,14.544199 32.5,32.5c0,17.955803 -14.544197,32.5 -32.5,32.5c-17.955803,0 -32.5,-14.544197 -32.5,-32.5c0,-17.955801 14.544197,-32.5 32.5,-32.5z";o.propTypes={progress:u.default.PropTypes.number},t.default=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.ProgressBar=t.ProgressRound=void 0;var o=n(18),a=r(o),u=n(59),i=r(u);t.ProgressRound=a.default,t.ProgressBar=i.default},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];return function(){for(var e=arguments.length,n=Array(e),r=0;r<e;r++)n[r]=arguments[r];return t.forEach(function(e){return e&&e.apply(void 0,n)})}}},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=function(e,t){if(e===t)return!0;if("undefined"==typeof e||"undefined"==typeof t)return e===t;if(null===e||null===t||"object"!==("undefined"==typeof e?"undefined":n(e))&&"object"!==("undefined"==typeof t?"undefined":n(t)))return e!==e&&t!==t;var r=Array.isArray(e),o=Array.isArray(t);if(r!==o)return!1;if(r&&o){if(e.length!==t.length)return!1;for(var a=0;a<e.length;a++)if(e[a]!==t[a])return!1}var u=Object.keys(e),i=Object.keys(t);if(u.length!==i.length)return!1;for(var l=0;l<u.length;l++)if(u[l]!==i[l]||e[u[l]]!==t[i[l]])return!1;return!0}},function(e,t,n){"use strict";function r(e){return e}function o(e,t,n){function o(e,t){var n=b.hasOwnProperty(t)?b[t]:null;P.hasOwnProperty(t)&&l("OVERRIDE_BASE"===n,"ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.",t),e&&l("DEFINE_MANY"===n||"DEFINE_MANY_MERGED"===n,"ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.",t)}function a(e,n){if(n){l("function"!=typeof n,"ReactClass: You're attempting to use a component class or function as a mixin. Instead, just use a regular object."),l(!t(n),"ReactClass: You're attempting to use a component as a mixin. Instead, just use a regular object.");var r=e.prototype,a=r.__reactAutoBindPairs;n.hasOwnProperty(c)&&g.mixins(e,n.mixins);for(var u in n)if(n.hasOwnProperty(u)&&u!==c){var i=n[u],s=r.hasOwnProperty(u);if(o(s,u),g.hasOwnProperty(u))g[u](e,i);else{var f=b.hasOwnProperty(u),h="function"==typeof i,v=h&&!f&&!s&&n.autobind!==!1;if(v)a.push(u,i),r[u]=i;else if(s){var y=b[u];l(f&&("DEFINE_MANY_MERGED"===y||"DEFINE_MANY"===y),"ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.",y,u),"DEFINE_MANY_MERGED"===y?r[u]=p(r[u],i):"DEFINE_MANY"===y&&(r[u]=d(r[u],i))}else r[u]=i}}}else;}function s(e,t){if(t)for(var n in t){var r=t[n];if(t.hasOwnProperty(n)){var o=n in g;l(!o,'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.',n);var a=n in e;l(!a,"ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.",n),e[n]=r}}}function f(e,t){l(e&&t&&"object"==typeof e&&"object"==typeof t,"mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.");for(var n in t)t.hasOwnProperty(n)&&(l(void 0===e[n],"mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.",n),e[n]=t[n]);return e}function p(e,t){return function(){var n=e.apply(this,arguments),r=t.apply(this,arguments);if(null==n)return r;if(null==r)return n;var o={};return f(o,n),f(o,r),o}}function d(e,t){return function(){e.apply(this,arguments),t.apply(this,arguments)}}function h(e,t){var n=t.bind(e);return n}function v(e){for(var t=e.__reactAutoBindPairs,n=0;n<t.length;n+=2){var r=t[n],o=t[n+1];e[r]=h(e,o)}}function y(e){var t=r(function(e,r,o){this.__reactAutoBindPairs.length&&v(this),this.props=e,this.context=r,this.refs=i,this.updater=o||n,this.state=null;var a=this.getInitialState?this.getInitialState():null;l("object"==typeof a&&!Array.isArray(a),"%s.getInitialState(): must return an object or null",t.displayName||"ReactCompositeComponent"),this.state=a});t.prototype=new E,t.prototype.constructor=t,t.prototype.__reactAutoBindPairs=[],m.forEach(a.bind(null,t)),a(t,_),a(t,e),a(t,O),t.getDefaultProps&&(t.defaultProps=t.getDefaultProps()),l(t.prototype.render,"createClass(...): Class specification must implement a `render` method.");for(var o in b)t.prototype[o]||(t.prototype[o]=null);return t}var m=[],b={mixins:"DEFINE_MANY",statics:"DEFINE_MANY",propTypes:"DEFINE_MANY",contextTypes:"DEFINE_MANY",childContextTypes:"DEFINE_MANY",getDefaultProps:"DEFINE_MANY_MERGED",getInitialState:"DEFINE_MANY_MERGED",getChildContext:"DEFINE_MANY_MERGED",render:"DEFINE_ONCE",componentWillMount:"DEFINE_MANY",componentDidMount:"DEFINE_MANY",componentWillReceiveProps:"DEFINE_MANY",shouldComponentUpdate:"DEFINE_ONCE",componentWillUpdate:"DEFINE_MANY",componentDidUpdate:"DEFINE_MANY",componentWillUnmount:"DEFINE_MANY",updateComponent:"OVERRIDE_BASE"},g={displayName:function(e,t){e.displayName=t},mixins:function(e,t){if(t)for(var n=0;n<t.length;n++)a(e,t[n])},childContextTypes:function(e,t){e.childContextTypes=u({},e.childContextTypes,t)},contextTypes:function(e,t){e.contextTypes=u({},e.contextTypes,t)},getDefaultProps:function(e,t){e.getDefaultProps?e.getDefaultProps=p(e.getDefaultProps,t):e.getDefaultProps=t},propTypes:function(e,t){e.propTypes=u({},e.propTypes,t)},statics:function(e,t){s(e,t)},autobind:function(){}},_={componentDidMount:function(){this.__isMounted=!0}},O={componentWillUnmount:function(){this.__isMounted=!1}},P={replaceState:function(e,t){this.updater.enqueueReplaceState(this,e,t)},isMounted:function(){return!!this.__isMounted}},E=function(){};return u(E.prototype,e.prototype,P),y}var a,u=n(6),i=n(19),l=n(2),c="mixins";a={},e.exports=o},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t,n){"use strict";function r(e,t,n,r,o){}e.exports=r},function(e,t,n){"use strict";var r=n(88);e.exports=function(e){var t=!1;return r(e,t)}},function(e,t,n){"use strict";var r=n(4),o=n(2),a=n(20);e.exports=function(){function e(e,t,n,r,u,i){i!==a&&o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var n={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t};return n.checkPropTypes=r,n.PropTypes=n,n}},function(e,t,n){"use strict";var r=n(4),o=n(2),a=n(5),u=n(20),i=n(85);e.exports=function(e,t){function n(e){var t=e&&(M&&e[M]||e[k]);if("function"==typeof t)return t}function l(e,t){return e===t?0!==e||1/e===1/t:e!==e&&t!==t}function c(e){this.message=e,this.stack=""}function s(e){function n(n,r,a,i,l,s,f){if(i=i||C,s=s||a,f!==u)if(t)o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");else;return null==r[a]?n?new c(null===r[a]?"The "+l+" `"+s+"` is marked as required "+("in `"+i+"`, but its value is `null`."):"The "+l+" `"+s+"` is marked as required in "+("`"+i+"`, but its value is `undefined`.")):null:e(r,a,i,l,s)}var r=n.bind(null,!1);return r.isRequired=n.bind(null,!0),r}function f(e){function t(t,n,r,o,a,u){var i=t[n],l=E(i);if(l!==e){var s=j(i);return new c("Invalid "+o+" `"+a+"` of type "+("`"+s+"` supplied to `"+r+"`, expected ")+("`"+e+"`."))}return null}return s(t)}function p(){return s(r.thatReturnsNull)}function d(e){function t(t,n,r,o,a){if("function"!=typeof e)return new c("Property `"+a+"` of component `"+r+"` has invalid PropType notation inside arrayOf.");var i=t[n];if(!Array.isArray(i)){var l=E(i);return new c("Invalid "+o+" `"+a+"` of type "+("`"+l+"` supplied to `"+r+"`, expected an array."))}for(var s=0;s<i.length;s++){var f=e(i,s,r,o,a+"["+s+"]",u);if(f instanceof Error)return f}return null}return s(t)}function h(){function t(t,n,r,o,a){var u=t[n];if(!e(u)){var i=E(u);return new c("Invalid "+o+" `"+a+"` of type "+("`"+i+"` supplied to `"+r+"`, expected a single ReactElement."))}return null}return s(t)}function v(e){function t(t,n,r,o,a){if(!(t[n]instanceof e)){var u=e.name||C,i=w(t[n]);return new c("Invalid "+o+" `"+a+"` of type "+("`"+i+"` supplied to `"+r+"`, expected ")+("instance of `"+u+"`."))}return null}return s(t)}function y(e){function t(t,n,r,o,a){for(var u=t[n],i=0;i<e.length;i++)if(l(u,e[i]))return null;var s=JSON.stringify(e);return new c("Invalid "+o+" `"+a+"` of value `"+u+"` "+("supplied to `"+r+"`, expected one of "+s+"."))}return Array.isArray(e)?s(t):r.thatReturnsNull}function m(e){function t(t,n,r,o,a){if("function"!=typeof e)return new c("Property `"+a+"` of component `"+r+"` has invalid PropType notation inside objectOf.");var i=t[n],l=E(i);if("object"!==l)return new c("Invalid "+o+" `"+a+"` of type "+("`"+l+"` supplied to `"+r+"`, expected an object."));for(var s in i)if(i.hasOwnProperty(s)){var f=e(i,s,r,o,a+"."+s,u);if(f instanceof Error)return f}return null}return s(t)}function b(e){function t(t,n,r,o,a){for(var i=0;i<e.length;i++){var l=e[i];if(null==l(t,n,r,o,a,u))return null}return new c("Invalid "+o+" `"+a+"` supplied to "+("`"+r+"`."))}if(!Array.isArray(e))return r.thatReturnsNull;for(var n=0;n<e.length;n++){var o=e[n];if("function"!=typeof o)return a(!1,"Invalid argument supplid to oneOfType. Expected an array of check functions, but received %s at index %s.",x(o),n),r.thatReturnsNull}return s(t)}function g(){function e(e,t,n,r,o){return O(e[t])?null:new c("Invalid "+r+" `"+o+"` supplied to "+("`"+n+"`, expected a ReactNode."))}return s(e)}function _(e){function t(t,n,r,o,a){var i=t[n],l=E(i);if("object"!==l)return new c("Invalid "+o+" `"+a+"` of type `"+l+"` "+("supplied to `"+r+"`, expected `object`."));for(var s in e){var f=e[s];if(f){var p=f(i,s,r,o,a+"."+s,u);if(p)return p}}return null}return s(t)}function O(t){switch(typeof t){case"number":case"string":case"undefined":return!0;case"boolean":return!t;case"object":if(Array.isArray(t))return t.every(O);if(null===t||e(t))return!0;var r=n(t);if(!r)return!1;var o,a=r.call(t);if(r!==t.entries){for(;!(o=a.next()).done;)if(!O(o.value))return!1}else for(;!(o=a.next()).done;){var u=o.value;if(u&&!O(u[1]))return!1}return!0;default:return!1}}function P(e,t){return"symbol"===e||("Symbol"===t["@@toStringTag"]||"function"==typeof Symbol&&t instanceof Symbol)}function E(e){var t=typeof e;return Array.isArray(e)?"array":e instanceof RegExp?"object":P(t,e)?"symbol":t}function j(e){if("undefined"==typeof e||null===e)return""+e;var t=E(e);if("object"===t){if(e instanceof Date)return"date";if(e instanceof RegExp)return"regexp"}return t}function x(e){var t=j(e);switch(t){case"array":case"object":return"an "+t;case"boolean":case"date":case"regexp":return"a "+t;default:return t}}function w(e){return e.constructor&&e.constructor.name?e.constructor.name:C}var M="function"==typeof Symbol&&Symbol.iterator,k="@@iterator",C="<<anonymous>>",T={array:f("array"),bool:f("boolean"),func:f("function"),number:f("number"),object:f("object"),string:f("string"),symbol:f("symbol"),any:p(),arrayOf:d,element:h(),instanceOf:v,node:g(),objectOf:m,oneOf:y,oneOfType:b,shape:_};return c.prototype=Error.prototype,T.checkPropTypes=i,T.PropTypes=T,T}},function(e,t,n){e.exports=n(87)()},function(e,t){"use strict";function n(e){var t=/[=:]/g,n={"=":"=0",":":"=2"},r=(""+e).replace(t,function(e){return n[e]});return"$"+r}function r(e){var t=/(=0|=2)/g,n={"=0":"=","=2":":"},r="."===e[0]&&"$"===e[1]?e.substring(2):e.substring(1);return(""+r).replace(t,function(e){return n[e]})}var o={escape:n,unescape:r};e.exports=o},function(e,t,n){"use strict";var r=n(7),o=(n(2),function(e){var t=this;if(t.instancePool.length){var n=t.instancePool.pop();return t.call(n,e),n}return new t(e)}),a=function(e,t){var n=this;if(n.instancePool.length){var r=n.instancePool.pop();return n.call(r,e,t),r}return new n(e,t)},u=function(e,t,n){var r=this;if(r.instancePool.length){var o=r.instancePool.pop();return r.call(o,e,t,n),o}return new r(e,t,n)},i=function(e,t,n,r){var o=this;if(o.instancePool.length){var a=o.instancePool.pop();return o.call(a,e,t,n,r),a}return new o(e,t,n,r)},l=function(e){var t=this;e instanceof t?void 0:r("25"),e.destructor(),t.instancePool.length<t.poolSize&&t.instancePool.push(e)},c=10,s=o,f=function(e,t){var n=e;return n.instancePool=[],n.getPooled=t||s,n.poolSize||(n.poolSize=c),n.release=l,n},p={addPoolingTo:f,oneArgumentPooler:o,twoArgumentPooler:a,threeArgumentPooler:u,fourArgumentPooler:i};e.exports=p},function(e,t,n){"use strict";var r=n(6),o=n(21),a=n(93),u=n(94),i=n(3),l=n(95),c=n(96),s=n(97),f=n(100),p=i.createElement,d=i.createFactory,h=i.cloneElement,v=r,y=function(e){return e},m={Children:{map:a.map,forEach:a.forEach,count:a.count,toArray:a.toArray,only:f},Component:o.Component,PureComponent:o.PureComponent,createElement:p,cloneElement:h,isValidElement:i.isValidElement,PropTypes:l,createClass:s,createFactory:d,createMixin:y,DOM:u,version:c,__spread:v};e.exports=m},function(e,t,n){"use strict";function r(e){return(""+e).replace(_,"$&/")}function o(e,t){this.func=e,this.context=t,this.count=0}function a(e,t,n){var r=e.func,o=e.context;r.call(o,t,e.count++)}function u(e,t,n){if(null==e)return e;var r=o.getPooled(t,n);m(e,a,r),o.release(r)}function i(e,t,n,r){this.result=e,this.keyPrefix=t,this.func=n,this.context=r,this.count=0}function l(e,t,n){var o=e.result,a=e.keyPrefix,u=e.func,i=e.context,l=u.call(i,t,e.count++);Array.isArray(l)?c(l,o,n,y.thatReturnsArgument):null!=l&&(v.isValidElement(l)&&(l=v.cloneAndReplaceKey(l,a+(!l.key||t&&t.key===l.key?"":r(l.key)+"/")+n)),o.push(l))}function c(e,t,n,o,a){var u="";null!=n&&(u=r(n)+"/");var c=i.getPooled(t,u,o,a);m(e,l,c),i.release(c)}function s(e,t,n){if(null==e)return e;var r=[];return c(e,r,null,t,n),r}function f(e,t,n){return null}function p(e,t){return m(e,f,null)}function d(e){var t=[];return c(e,t,null,y.thatReturnsArgument),t}var h=n(91),v=n(3),y=n(4),m=n(101),b=h.twoArgumentPooler,g=h.fourArgumentPooler,_=/\/+/g;o.prototype.destructor=function(){this.func=null,this.context=null,this.count=0},h.addPoolingTo(o,b),i.prototype.destructor=function(){this.result=null,this.keyPrefix=null,this.func=null,this.context=null,this.count=0},h.addPoolingTo(i,g);var O={forEach:u,map:s,mapIntoWithKeyPrefixInternal:c,count:p,toArray:d};e.exports=O},function(e,t,n){"use strict";var r=n(3),o=r.createFactory,a={a:o("a"),abbr:o("abbr"),address:o("address"),area:o("area"),article:o("article"),aside:o("aside"),audio:o("audio"),b:o("b"),base:o("base"),bdi:o("bdi"),bdo:o("bdo"),big:o("big"),blockquote:o("blockquote"),body:o("body"),br:o("br"),button:o("button"),canvas:o("canvas"),caption:o("caption"),cite:o("cite"),code:o("code"),col:o("col"),colgroup:o("colgroup"),data:o("data"),datalist:o("datalist"),dd:o("dd"),del:o("del"),details:o("details"),dfn:o("dfn"),dialog:o("dialog"),div:o("div"),dl:o("dl"),dt:o("dt"),em:o("em"),embed:o("embed"),fieldset:o("fieldset"),figcaption:o("figcaption"),figure:o("figure"),footer:o("footer"),form:o("form"),h1:o("h1"),h2:o("h2"),h3:o("h3"),h4:o("h4"),h5:o("h5"),h6:o("h6"),head:o("head"),header:o("header"),hgroup:o("hgroup"),hr:o("hr"),html:o("html"),i:o("i"),iframe:o("iframe"),img:o("img"),input:o("input"),ins:o("ins"),kbd:o("kbd"),keygen:o("keygen"),label:o("label"),legend:o("legend"),li:o("li"),link:o("link"),main:o("main"),map:o("map"),mark:o("mark"),menu:o("menu"),menuitem:o("menuitem"),meta:o("meta"),meter:o("meter"),nav:o("nav"),noscript:o("noscript"),object:o("object"),ol:o("ol"),optgroup:o("optgroup"),option:o("option"),output:o("output"),p:o("p"),param:o("param"),picture:o("picture"),pre:o("pre"),progress:o("progress"),q:o("q"),rp:o("rp"),rt:o("rt"),ruby:o("ruby"),s:o("s"),samp:o("samp"),script:o("script"),section:o("section"),select:o("select"),small:o("small"),source:o("source"),span:o("span"),strong:o("strong"),style:o("style"),sub:o("sub"),summary:o("summary"),sup:o("sup"),table:o("table"),tbody:o("tbody"),td:o("td"),textarea:o("textarea"),tfoot:o("tfoot"),th:o("th"),thead:o("thead"),time:o("time"),title:o("title"),tr:o("tr"),track:o("track"),u:o("u"),ul:o("ul"),var:o("var"),video:o("video"),wbr:o("wbr"),circle:o("circle"),clipPath:o("clipPath"),defs:o("defs"),ellipse:o("ellipse"),g:o("g"),image:o("image"),line:o("line"),linearGradient:o("linearGradient"),mask:o("mask"),path:o("path"),pattern:o("pattern"),polygon:o("polygon"),polyline:o("polyline"),radialGradient:o("radialGradient"),rect:o("rect"),stop:o("stop"),svg:o("svg"),text:o("text"),tspan:o("tspan")};e.exports=a},function(e,t,n){"use strict";var r=n(3),o=r.isValidElement,a=n(86);e.exports=a(o)},function(e,t){"use strict";e.exports="15.6.1"},function(e,t,n){"use strict";var r=n(21),o=r.Component,a=n(3),u=a.isValidElement,i=n(24),l=n(64);e.exports=l(o,u,i)},function(e,t){"use strict";function n(e){var t=e&&(r&&e[r]||e[o]);if("function"==typeof t)return t}var r="function"==typeof Symbol&&Symbol.iterator,o="@@iterator";e.exports=n},function(e,t,n){"use strict";var r=function(){};e.exports=r},function(e,t,n){"use strict";function r(e){return a.isValidElement(e)?void 0:o("143"),e}var o=n(7),a=n(3);n(2);e.exports=r},function(e,t,n){"use strict";function r(e,t){return e&&"object"==typeof e&&null!=e.key?c.escape(e.key):t.toString(36)}function o(e,t,n,a){var p=typeof e;if("undefined"!==p&&"boolean"!==p||(e=null),null===e||"string"===p||"number"===p||"object"===p&&e.$$typeof===i)return n(a,e,""===t?s+r(e,0):t),1;var d,h,v=0,y=""===t?s:t+f;if(Array.isArray(e))for(var m=0;m<e.length;m++)d=e[m],h=y+r(d,m),v+=o(d,h,n,a);else{var b=l(e);if(b){var g,_=b.call(e);if(b!==e.entries)for(var O=0;!(g=_.next()).done;)d=g.value,h=y+r(d,O++),v+=o(d,h,n,a);else for(;!(g=_.next()).done;){var P=g.value;P&&(d=P[1],h=y+c.escape(P[0])+f+r(d,0),v+=o(d,h,n,a))}}else if("object"===p){var E="",j=String(e);u("31","[object Object]"===j?"object with keys {"+Object.keys(e).join(", ")+"}":j,E)}}return v}function a(e,t,n){return null==e?0:o(e,"",t,n)}var u=n(7),i=(n(22),n(23)),l=n(98),c=(n(2),n(90)),s=(n(5),"."),f=":";e.exports=a}])});

/***/ }),

/***/ "xZmo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yhus":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ysQM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z2GC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

/******/ });
});


// WEBPACK FOOTER //
// index.57ecce4760e0d5f32682.js